export const gosMonsters = [
  {
    name: "Amphisbaena",
    source: "GoS",
    page: 230,
    otherSources: [
      {
        source: "MOT",
      },
    ],
    size: ["M"],
    type: "monstrosity",
    alignment: ["U"],
    ac: [14],
    hp: {
      average: 11,
      formula: "2d8 + 2",
    },
    speed: {
      walk: 30,
      swim: 30,
    },
    str: 14,
    dex: 18,
    con: 12,
    int: 3,
    wis: 10,
    cha: 3,
    skill: {
      perception: "+2",
    },
    senses: ["blindsight 10 ft."],
    passive: 12,
    cr: "1/2",
    trait: [
      {
        name: "Two Heads",
        entries: [
          "The amphisbaena has advantage on Wisdom (Perception) checks and on saving throws against being {blinded}, {charmed}, {deafened}, {frightened}, {stunned}, and knocked {unconscious}.",
        ],
      },
    ],
    action: [
      {
        name: "Multiattack",
        entries: ["The amphisbaena makes two bite attacks."],
      },
      {
        name: "Bite",
        entries: [
          "{6} to hit, reach 5 ft., one target. 6 ( 1d4 + 4}) piercing damage, and the target must make a {11} Constitution saving throw, taking 3 ( 1d6}) poison damage on a failed save, or half as much damage on a successful one.",
        ],
      },
    ],
    altArt: [
      {
        name: "Amphisbaena",
        source: "MOT",
      },
    ],
    senseTags: ["B"],
    actionTags: ["Multiattack"],
    damageTags: ["I", "P"],
    miscTags: ["MW"],
    hasToken: true,
    hasFluff: true,
  },
  {
    name: "Barnacle Bess",
    isNpc: true,
    isNamedCreature: true,
    source: "GoS",
    page: 220,
    _copy: {
      name: "Giant Crab",
      source: "MM",
      _mod: {
        "*": {
          mode: "replaceTxt",
          replace: "the crab",
          with: "Bess",
          flags: "i",
        },
      },
    },
    alignment: ["L", "N"],
    int: 10,
    languages: ["Common"],
    languageTags: ["C"],
    hasToken: true,
  },
  {
    name: "Bullywug Croaker",
    source: "GoS",
    page: 232,
    size: ["M"],
    type: {
      type: "humanoid",
      tags: ["bullywug"],
    },
    alignment: ["N", "E"],
    ac: [
      {
        ac: 15,
        from: ["{@item hide armor|phb}", "{@item shield|phb}"],
      },
    ],
    hp: {
      average: 33,
      formula: "6d8 + 6",
    },
    speed: {
      walk: 20,
      swim: 40,
    },
    str: 14,
    dex: 12,
    con: 12,
    int: 7,
    wis: 15,
    cha: 10,
    save: {
      con: "+3",
    },
    skill: {
      perception: "+4",
      stealth: "+3",
    },
    passive: 14,
    languages: ["Bullywug"],
    cr: "2",
    trait: [
      {
        name: "Amphibious",
        entries: ["The croaker can breathe air and water."],
      },
      {
        name: "Speak with Frogs and Toads",
        entries: [
          "The croaker can communicate simple concepts to frogs and toads when it speaks in Bullywug.",
        ],
      },
      {
        name: "Standing Leap",
        entries: [
          "The croaker's long jump is up to 20 feet and its high jump is up to 10 feet, with or without a running start.",
        ],
      },
      {
        name: "Swamp Camouflage",
        entries: [
          "The croaker has advantage on Dexterity (Stealth) checks made to hide in swampy terrain.",
        ],
      },
    ],
    action: [
      {
        name: "Spear",
        entries: [
          "{4} to hit, reach 5 ft. or range 20/60 ft., one target. 5 ( 1d6 + 2}) piercing damage, or 6 ( 1d8 + 2}) piercing damage if used with two hands to make a melee attack.",
        ],
      },
      {
        name: "Bite",
        entries: [
          "{4} to hit, reach 5 ft., one target. 5 ( 1d6 + 2}) piercing damage.",
        ],
      },
      {
        name: "Glaaar-pat (3/Day)",
        entries: [
          "The croaker sings a song of marshy doom. Each chosen creature within 30 feet of the croaker that can hear the song must make a {12} Wisdom saving throw, taking 9 ( 2d8}) psychic damage on a failed save, or half as much damage on a successful one. A creature that fails this saving throw also has disadvantage on Constitution saving throws until the end of its next turn.",
        ],
      },
      {
        name: "Rooooo-glog (1/Day)",
        entries: [
          "The croaker sings an ode to an elder Froghemoth. Each bullywug within 30 feet of the croaker that can hear the song gains 10 temporary hit points.",
        ],
      },
    ],
    attachedItems: ["spear|phb"],
    traitTags: ["Amphibious"],
    languageTags: ["OTH"],
    damageTags: ["P", "Y"],
    miscTags: ["MW", "RW", "THW"],
    hasToken: true,
    hasFluff: true,
  },
  {
    name: "Bullywug Royal",
    source: "GoS",
    page: 232,
    otherSources: [
      {
        source: "WBtW",
      },
    ],
    size: ["M"],
    type: {
      type: "humanoid",
      tags: ["bullywug"],
    },
    alignment: ["N", "E"],
    ac: [
      {
        ac: 15,
        from: ["{@item hide armor|phb}", "{@item shield|phb}"],
      },
    ],
    hp: {
      average: 52,
      formula: "8d8 + 16",
    },
    speed: {
      walk: 20,
      swim: 40,
    },
    str: 16,
    dex: 12,
    con: 14,
    int: 10,
    wis: 11,
    cha: 14,
    save: {
      str: "+5",
      dex: "+3",
    },
    skill: {
      athletics: "+5",
      intimidation: "+4",
      stealth: "+3",
    },
    passive: 10,
    languages: ["Bullywug"],
    cr: "3",
    trait: [
      {
        name: "Amphibious",
        entries: ["The royal can breathe air and water."],
      },
      {
        name: "Brute",
        entries: [
          "A melee weapon deals one extra die of its damage when the royal hits with it (included in the attack).",
        ],
      },
      {
        name: "Frog Rider",
        entries: [
          "The royal has advantage on melee attacks made while riding a frog mount.",
        ],
      },
      {
        name: "Speak with Frogs and Toads",
        entries: [
          "The royal can communicate simple concepts to frogs and toads when it speaks in Bullywug.",
        ],
      },
      {
        name: "Standing Leap",
        entries: [
          "The royal's long jump is up to 20 feet and its high jump is up to 10 feet, with or without a running start.",
        ],
      },
      {
        name: "Swamp Camouflage",
        entries: [
          "The royal has advantage on Dexterity (Stealth) checks made to hide in swampy terrain.",
        ],
      },
    ],
    action: [
      {
        name: "Multiattack",
        entries: [
          "The royal makes two attacks: one with its royal spear and one with its bite.",
        ],
      },
      {
        name: "Royal Spear",
        entries: [
          "{5} to hit, reach 10 ft. or range 20/60 ft., one target. 10 ( 2d6 + 3}) piercing damage, or 12 ( 2d8 + 3}) piercing damage if used with two hands to make a melee attack. If the target is a Medium or smaller creature, it must succeed on a {13} Strength saving throw or be knocked {prone}.",
        ],
      },
      {
        name: "Bite",
        entries: [
          "{5} to hit, reach 5 ft., one target. 6 ( 1d6 + 3}) piercing damage.",
        ],
      },
      {
        name: "Croaked Decree (1/Day)",
        entries: [
          "The royal makes a loud pronouncement. Each bullywug within 60 feet of the royal that can hear the pronouncement has advantage on its next attack roll.",
        ],
      },
    ],
    traitTags: ["Amphibious", "Brute"],
    actionTags: ["Multiattack"],
    languageTags: ["OTH"],
    damageTags: ["P"],
    miscTags: ["MW", "RCH", "RW", "THW"],
    conditionInflict: ["prone"],
    hasToken: true,
    hasFluff: true,
  },
  {
    name: "Captain Xendros",
    shortName: "Xendros",
    isNpc: true,
    isNamedCreature: true,
    source: "GoS",
    page: 14,
    _copy: {
      name: "Priest",
      source: "MM",
      _trait: {
        name: "Tiefling",
        source: "PHB",
      },
      _mod: {
        "*": {
          mode: "replaceTxt",
          replace: "the priest",
          with: "Xendros",
          flags: "i",
        },
      },
    },
    alignment: ["C", "E"],
    senseTags: ["D"],
    languageTags: ["I", "X"],
    damageTagsSpell: ["F", "N", "O", "R"],
    spellcastingTags: ["CC", "I"],
    hasToken: true,
    hasFluffImages: true,
  },
  {
    name: "Drowned Ascetic",
    source: "GoS",
    page: 233,
    otherSources: [
      {
        source: "LR",
      },
    ],
    size: ["M"],
    type: "undead",
    alignment: ["C", "E"],
    ac: [13],
    hp: {
      average: 75,
      formula: "10d8 + 30",
    },
    speed: {
      walk: 30,
    },
    str: 12,
    dex: 16,
    con: 16,
    int: 3,
    wis: 9,
    cha: 5,
    save: {
      dex: "+5",
    },
    senses: ["darkvision 60 ft."],
    passive: 9,
    immune: ["poison"],
    conditionImmune: ["poisoned"],
    languages: ["understands the languages it knew in life but can't speak"],
    cr: "3",
    trait: [
      {
        name: "Bottom Treader",
        entries: [
          "The drowned ascetic cannot swim, and it sinks to the bottom of any body of water. It takes no penalties to its movement or attacks underwater. It is immune to the effects of being underwater at a depth greater than 100 feet.",
        ],
      },
      {
        name: "Bound Together",
        entries: [
          "The drowned ascetic shares its mind with every other drowned one within 1 mile of it, and can communicate its thoughts and observations to them instantaneously and without limitation.",
        ],
      },
      {
        name: "Undead Fortitude",
        entries: [
          "If damage reduces the drowned ascetic to 0 hit points, it must make a Constitution saving throw with a DC of 5 + the damage taken, unless the damage is radiant or from a Critical Hit. On a success, the drowned ascetic drops to 1 hit point instead.",
        ],
      },
    ],
    action: [
      {
        name: "Multiattack",
        entries: ["The drowned ascetic makes three unarmed strikes."],
      },
      {
        name: "Unarmed Strike",
        entries: [
          '{5} to hit, reach 5 ft., one target. 7 ( 1d8 + 3}) bludgeoning damage, and the target must succeed on a {12} Constitution saving throw or contract {@disease bluerot|GoS} (see the "Bluerot" in notes).',
        ],
      },
    ],
    reaction: [
      {
        name: "Dexterous Target",
        entries: [
          "The drowned ascetic adds 3 to its AC against one ranged attack that would hit it. To do so, the drowned ascetic must see the attacker.",
        ],
      },
    ],
    traitTags: ["Undead Fortitude"],
    senseTags: ["D"],
    actionTags: ["Multiattack"],
    languageTags: ["CS", "LF"],
    damageTags: ["B"],
    miscTags: ["MW"],
    hasToken: true,
    hasFluff: true,
    hasFluffImages: true,
  },
  {
    name: "Drowned Assassin",
    source: "GoS",
    page: 234,
    otherSources: [
      {
        source: "LR",
      },
    ],
    size: ["M"],
    type: "undead",
    alignment: ["C", "E"],
    ac: [
      {
        ac: 14,
        from: ["{@item Leather Armor|phb}"],
      },
    ],
    hp: {
      average: 67,
      formula: "9d8 + 27",
    },
    speed: {
      walk: 30,
    },
    str: 15,
    dex: 16,
    con: 16,
    int: 9,
    wis: 9,
    cha: 16,
    save: {
      dex: "+5",
      con: "+5",
    },
    skill: {
      intimidation: "+5",
      stealth: "+5",
    },
    senses: ["darkvision 60 ft."],
    passive: 9,
    immune: ["poison"],
    conditionImmune: ["poisoned"],
    languages: ["understands the languages it knew in life but can't speak"],
    cr: "4",
    trait: [
      {
        name: "Bottom Treader",
        entries: [
          "The drowned assassin cannot swim, and it sinks to the bottom of any body of water. It takes no penalties to its movement or attacks underwater. It is immune to the effects of being underwater at a depth greater than 100 feet.",
        ],
      },
      {
        name: "Bound Together",
        entries: [
          "The drowned assassin shares its mind with every other drowned one within 1 mile of it, and can communicate its thoughts and observations to them instantaneously and without limitation.",
        ],
      },
      {
        name: "Undead Fortitude",
        entries: [
          "If damage reduces the drowned assassin to 0 hit points, it must make a Constitution saving throw with a DC of 5 + the damage taken, unless the damage is radiant or from a Critical Hit. On a success, the drowned assassin drops to 1 hit point instead.",
        ],
      },
    ],
    action: [
      {
        name: "Multiattack",
        entries: [
          "The drowned assassin makes two hand crossbow attacks or two dagger attacks. It can then take the Dash, Disengage, or Hide action.",
        ],
      },
      {
        name: "Hand Crossbow",
        entries: [
          '{5} to hit, range 30/120 ft., one target. 6 ( 1d6 + 3}) piercing damage plus 3 ( 1d6}) poison damage, and the target must succeed on a {12} Constitution saving throw or contract {@disease bluerot|GoS} (see the "Bluerot" in notes).',
        ],
      },
      {
        name: "Dagger",
        entries: [
          '{5} to hit, reach 5 ft., one target. 5 ( 1d4 + 3}) piercing damage plus 9 ( 2d8}) poison damage, and the target must succeed on a {12} Constitution saving throw or contract {@disease bluerot|GoS} (see the "Bluerot" in notes).',
        ],
      },
      {
        name: "Reveal (1/Day)",
        entries: [
          "The drowned assassin removes its mask, revealing its rotting face. Each creature of the assassin's choice within 30 feet of it that can see the assassin must succeed on a {13} Wisdom saving throw or be {frightened} until the end of its next turn.",
        ],
      },
    ],
    attachedItems: ["dagger|phb", "hand crossbow|phb"],
    traitTags: ["Undead Fortitude"],
    senseTags: ["D"],
    actionTags: ["Multiattack"],
    languageTags: ["CS", "LF"],
    damageTags: ["I", "P"],
    miscTags: ["MW", "RNG", "RW"],
    conditionInflict: ["frightened"],
    hasToken: true,
    hasFluff: true,
    hasFluffImages: true,
  },
  {
    name: "Drowned Blade",
    source: "GoS",
    page: 235,
    otherSources: [
      {
        source: "LR",
      },
    ],
    size: ["M"],
    type: "undead",
    alignment: ["C", "E"],
    ac: [
      {
        ac: 10,
        from: ["{@item Leather Armor|phb}"],
      },
    ],
    hp: {
      average: 45,
      formula: "6d8 + 18",
    },
    speed: {
      walk: 30,
    },
    str: 16,
    dex: 8,
    con: 16,
    int: 3,
    wis: 9,
    cha: 5,
    senses: ["darkvision 60 ft."],
    passive: 9,
    immune: ["poison"],
    conditionImmune: ["poisoned"],
    languages: ["understands the languages it knew in life but can't speak"],
    cr: "2",
    trait: [
      {
        name: "Bottom Treader",
        entries: [
          "The drowned blade cannot swim, and it sinks to the bottom of any body of water. It takes no penalties to its movement or attacks underwater. It is immune to the effects of being underwater at a depth greater than 100 feet.",
        ],
      },
      {
        name: "Bound Together",
        entries: [
          "The drowned blade shares its mind with every other drowned one within 1 mile of it, and can communicate its thoughts and observations to them instantaneously and without limitation.",
        ],
      },
      {
        name: "Undead Fortitude",
        entries: [
          "If damage reduces the drowned blade to 0 hit points, it must make a Constitution saving throw with a DC of 5 + the damage taken, unless the damage is radiant or from a Critical Hit. On a success, the drowned blade drops to 1 hit point instead.",
        ],
      },
    ],
    action: [
      {
        name: "Multiattack",
        entries: ["The drowned blade makes two rusted longsword attacks."],
      },
      {
        name: "Rusted Longsword",
        entries: [
          '{5} to hit, reach 5 ft., one target. 7 ( 1d8 + 3}) slashing damage, and the target must succeed on a {12} Constitution saving throw or contract {@disease bluerot|GoS} (see the "Bluerot" in notes).',
        ],
      },
    ],
    traitTags: ["Undead Fortitude"],
    senseTags: ["D"],
    actionTags: ["Multiattack"],
    languageTags: ["CS", "LF"],
    damageTags: ["S"],
    miscTags: ["MW"],
    hasToken: true,
    hasFluff: true,
    hasFluffImages: true,
  },
  {
    name: "Drowned Master",
    source: "GoS",
    page: 235,
    otherSources: [
      {
        source: "LR",
      },
    ],
    size: ["M"],
    type: "undead",
    alignment: ["C", "E"],
    ac: [
      {
        ac: 14,
        from: ["natural armor"],
      },
    ],
    hp: {
      average: 157,
      formula: "21d8 + 63",
    },
    speed: {
      walk: 30,
    },
    str: 17,
    dex: 12,
    con: 16,
    int: 9,
    wis: 14,
    cha: 12,
    save: {
      con: "+7",
      wis: "+6",
    },
    skill: {
      perception: "+10",
    },
    senses: ["darkvision 60 ft."],
    passive: 20,
    immune: ["poison"],
    conditionImmune: ["poisoned"],
    languages: ["understands the languages it knew in life but can't speak"],
    cr: "9",
    trait: [
      {
        name: "Bound Together",
        entries: [
          "The drowned master shares its mind with every other drowned one within 1 mile of it, and can communicate its thoughts and observations to them instantaneously and without limitation.",
        ],
      },
      {
        name: "Cold Aura",
        entries: [
          "At the start of each of the drowned master's turns, each creature within 5 feet of it takes 5 ( 1d10}) cold damage. A creature that touches the drowned master or hits it with a melee attack while within 5 feet of it takes 5 ( 1d10}) cold damage.",
        ],
      },
      {
        name: "Undead Fortitude",
        entries: [
          "If damage reduces the drowned master to 0 hit points, it must make a Constitution saving throw with a DC of 5 + the damage taken, unless the damage is radiant or from a Critical Hit. On a success, the drowned master drops to 1 hit point instead.",
        ],
      },
    ],
    action: [
      {
        name: "Multiattack",
        entries: [
          "The drowned master makes two attacks: one with its Greatsword and one with its Life-Draining Tentacle.",
        ],
      },
      {
        name: "Greatsword",
        entries: [
          '{7} to hit, reach 5 ft., one target. 10 ( 2d6 + 3}) slashing damage plus 14 ( 4d6}) cold damage, and the target must succeed on a {12} Constitution saving throw or contract {@disease bluerot|GoS} (see the "Bluerot" in notes).',
        ],
      },
      {
        name: "Life-Draining Tentacle",
        entries: [
          '{7} to hit, reach 15 ft., one target. 10 ( 2d6 + 3}) necrotic damage. The target must succeed on a {15} Constitution saving throw or have its hit point maximum reduced by an amount equal to the damage taken. The target dies if this effect reduces its hit point maximum to 0. This reduction lasts until the target finishes a Long Rest. On a failed save, the target also contracts bluerot (see the "Bluerot" in notes).',
        ],
      },
      {
        name: "Necrotic Ink {@recharge 5}",
        entries: [
          'The drowned master discharges foul ink in front of itself in a 30-foot cone. Each creature caught in the ink must make a {15} Constitution saving throw, taking 27 ( 6d8}) necrotic damage on a failed save or half as much damage on a successful one. A creature that fails this saving throw is {blinded} until the end of its next turn and contracts bluerot (see the "Bluerot" in notes).',
        ],
      },
    ],
    attachedItems: ["Greatsword|phb"],
    traitTags: ["Undead Fortitude"],
    senseTags: ["D"],
    actionTags: ["Multiattack"],
    languageTags: ["CS", "LF"],
    damageTags: ["C", "N", "S"],
    miscTags: ["AOE", "MW", "RCH"],
    conditionInflict: ["blinded"],
    hasToken: true,
    hasFluff: true,
    hasFluffImages: true,
  },
  {
    name: "Fish",
    source: "GoS",
    page: 224,
    _copy: {
      name: "Quipper",
      source: "MM",
      _mod: {
        "*": {
          mode: "replaceTxt",
          replace: "quipper",
          with: "fish",
          flags: "i",
        },
        trait: {
          mode: "removeArr",
          names: "Blood Frenzy",
        },
      },
    },
    action: null,
    damageTags: [],
    miscTags: [],
    hasToken: true,
  },
  {
    name: "Giant Coral Snake",
    source: "GoS",
    page: 236,
    size: ["L"],
    type: "beast",
    alignment: ["U"],
    ac: [13],
    hp: {
      average: 90,
      formula: "12d10 + 24",
    },
    speed: {
      walk: 30,
      swim: 30,
    },
    str: 12,
    dex: 16,
    con: 14,
    int: 2,
    wis: 10,
    cha: 3,
    skill: {
      perception: "+2",
    },
    senses: ["blindsight 10 ft."],
    passive: 12,
    cr: "4",
    action: [
      {
        name: "Bite",
        entries: [
          '{5} to hit, reach 5 ft., one target. 8 ( 2d4 + 3}) piercing damage, and the target must succeed on a {12} Constitution saving throw or be {stunned} until the end of its next turn. On a failed save, the target begins to hallucinate and is afflicted with a {@table short-term madness|DMG} effect (determined randomly or by the DM; see "Madness" in chapter 8 of the {@book Dungeon Master\'s Guide|dmg|8|madness}). The effect lasts 10 minutes.',
        ],
      },
    ],
    senseTags: ["B"],
    damageTags: ["P"],
    miscTags: ["MW"],
    conditionInflict: ["stunned"],
    hasToken: true,
    hasFluff: true,
  },
  {
    name: "Giant Sea Eel",
    source: "GoS",
    page: 237,
    size: ["L"],
    type: "beast",
    alignment: ["U"],
    ac: [
      {
        ac: 14,
        from: ["natural armor"],
      },
    ],
    hp: {
      average: 19,
      formula: "3d10 + 3",
    },
    speed: {
      walk: 0,
      swim: 40,
    },
    str: 11,
    dex: 14,
    con: 12,
    int: 7,
    wis: 10,
    cha: 7,
    save: {
      dex: "+4",
    },
    skill: {
      perception: "+2",
      stealth: "+4",
    },
    senses: ["darkvision 60 ft."],
    passive: 12,
    cr: "1/2",
    trait: [
      {
        name: "Water Breathing",
        entries: ["The eel can breathe only underwater."],
      },
    ],
    action: [
      {
        name: "Bite",
        entries: [
          "{4} to hit, reach 5 ft., one target. 13 ( 2d10 + 2}) piercing damage.",
        ],
      },
    ],
    traitTags: ["Water Breathing"],
    senseTags: ["D"],
    damageTags: ["P"],
    miscTags: ["MW"],
    hasToken: true,
    hasFluff: true,
  },
  {
    name: "Giant White Moray Eel",
    source: "GoS",
    page: 216,
    _copy: {
      name: "Giant Constrictor Snake",
      source: "MM",
      _mod: {
        "*": {
          mode: "replaceTxt",
          replace: "snake",
          with: "eel",
          flags: "i",
        },
        trait: {
          mode: "prependArr",
          items: {
            name: "Water Breathing",
            entries: ["The eel can breathe only underwater."],
          },
        },
        action: {
          mode: "removeArr",
          names: "Constrict",
        },
      },
    },
    speed: {
      walk: 0,
      swim: 40,
    },
    skill: {
      perception: "+2",
      stealth: "+4",
    },
    traitTags: ["Water Breathing"],
    damageTags: ["P"],
    hasToken: true,
  },
  {
    name: "Harpy Matriarch",
    source: "GoS",
    page: 237,
    size: ["M"],
    type: "monstrosity",
    alignment: ["C", "E"],
    ac: [
      {
        ac: 14,
        from: ["natural armor"],
      },
    ],
    hp: {
      average: 88,
      formula: "16d8 + 16",
    },
    speed: {
      walk: 20,
      fly: 40,
    },
    str: 13,
    dex: 16,
    con: 12,
    int: 9,
    wis: 10,
    cha: 16,
    save: {
      dex: "+6",
      cha: "+6",
    },
    skill: {
      perception: "+3",
    },
    senses: ["darkvision 60 ft."],
    passive: 13,
    languages: ["Common"],
    cr: "5",
    trait: [
      {
        name: "Luring Maestro",
        entries: [
          "While within 60 feet of the matriarch, creatures have disadvantage on saving throws against the matriarch's Luring Song.",
        ],
      },
      {
        name: "Magic Resistance",
        entries: [
          "The matriarch has advantage on saving throws against spells and other magical effects.",
        ],
      },
    ],
    action: [
      {
        name: "Multiattack",
        entries: ["The matriarch makes two claws attacks."],
      },
      {
        name: "Claws",
        entries: [
          "{6} to hit, reach 5 ft., one target. 13 ( 3d6 + 3}) slashing damage.",
        ],
      },
      {
        name: "Fleeting Form",
        entries: [
          "The matriarch can magically disguise itself to resemble a humanoid of roughly similar size and shape for up to 1 hour. It can revert to its true form as a bonus action. This illusion does not hold up to close scrutiny.",
        ],
      },
      {
        name: "Luring Song",
        entries: [
          "The matriarch sings a magical melody. Every humanoid and giant within 300 feet of the matriarch that can hear the song must succeed on a {14} Wisdom saving throw or be {charmed} until the song ends. The matriarch must take a bonus action on its subsequent turns to continue singing. It can stop singing at any time. The song ends if the matriarch is {incapacitated}.",
          "While {charmed} by the matriarch, a target is {incapacitated} and ignores the songs of other harpies. If the {charmed} target is more than 5 feet away from the matriarch, the target must move on its turn toward the matriarch by the most direct route, trying to get within 5 feet. It doesn't avoid opportunity attacks, but before moving into damaging terrain, such as lava or a pit, and whenever it takes damage from a source other than the matriarch, the target can repeat the saving throw. A {charmed} target can also repeat the saving throw at the end of each of its turns. If the saving throw is successful, the effect ends on it.",
          "A target that successfully saves is immune to this matriarch's song for the next 24 hours.",
        ],
      },
      {
        name: "Visage of Desire (1/Day)",
        entries: [
          "The matriarch projects a vision into the minds of creatures within 30 feet of it that aren't constructs or undead, showing each creature achieving whatever it most desires. An affected creature must succeed on a {14} Wisdom saving throw or drop whatever it is holding and become {paralyzed} until the end of its next turn.",
        ],
      },
    ],
    traitTags: ["Magic Resistance"],
    senseTags: ["D"],
    actionTags: ["Multiattack"],
    languageTags: ["C"],
    damageTags: ["S"],
    miscTags: ["MW"],
    conditionInflict: ["charmed", "incapacitated"],
    hasToken: true,
    hasFluff: true,
  },
  {
    name: "Juvenile Kraken",
    source: "GoS",
    page: 238,
    size: ["H"],
    type: {
      type: "monstrosity",
      tags: ["titan"],
    },
    alignment: ["C", "E"],
    ac: [
      {
        ac: 16,
        from: ["natural armor"],
      },
    ],
    hp: {
      average: 207,
      formula: "18d12 + 90",
    },
    speed: {
      walk: 20,
      swim: 50,
    },
    str: 24,
    dex: 11,
    con: 20,
    int: 19,
    wis: 15,
    cha: 17,
    save: {
      str: "+12",
      dex: "+5",
      con: "+10",
      int: "+9",
      wis: "+7",
    },
    senses: ["truesight 120 ft."],
    passive: 12,
    resist: [
      {
        resist: ["bludgeoning", "piercing", "slashing"],
        note: "from nonmagical attacks",
        cond: true,
      },
    ],
    immune: ["lightning"],
    conditionImmune: ["frightened", "paralyzed"],
    languages: [
      "Abyssal",
      "Celestial",
      "Infernal",
      "Primordial",
      "telepathy 60 ft. but can't speak",
    ],
    cr: "14",
    trait: [
      {
        name: "Amphibious",
        entries: ["The kraken can breathe air and water."],
      },
      {
        name: "Freedom of Movement",
        entries: [
          "The kraken ignores {@quickref difficult terrain||3}, and magical effects can't reduce its speed or cause it to be {restrained}. It can spend 5 feet of movement to escape from nonmagical restraints or being {grappled}.",
        ],
      },
    ],
    action: [
      {
        name: "Multiattack",
        entries: [
          "The kraken makes two tentacle attacks, each of which it can replace with a use of Fling.",
        ],
      },
      {
        name: "Bite",
        entries: [
          "{12} to hit, reach 5 ft., one target. 20 ( 3d8 + 7}) piercing damage. If the target is a Medium or smaller creature {grappled} by the kraken, that creature is swallowed and the grapple ends. While swallowed, the creature is {blinded} and {restrained}, it has total cover against attacks and other effects outside the kraken, and it takes 21 ( 6d6}) acid damage at the start of each of the kraken's turns. One Medium or two smaller creatures can be swallowed at the same time.",
          "If the kraken takes 35 damage or more on a single turn from a creature inside it, the kraken must succeed on a {23} Constitution saving throw at the end of that turn or regurgitate all swallowed creatures, which fall {prone} in spaces within 10 feet of the kraken. If the kraken dies, a swallowed creature is no longer {restrained} by it and can escape from the corpse using 10 feet of movement, exiting {prone}.",
        ],
      },
      {
        name: "Tentacle",
        entries: [
          "{12} to hit, reach 20 ft., one target. 17 ( 3d6 + 7}) bludgeoning damage, and the target is {grappled} (escape {20}). Until the grapple ends, the target is {restrained}. The kraken has ten tentacles, each of which can grapple one target.",
        ],
      },
      {
        name: "Fling",
        entries: [
          "One Medium or smaller object held or creature {grappled} by the kraken is thrown up to 40 feet in a random direction and knocked {prone}. If a thrown target strikes a solid surface, the target takes 3 ( 1d6}) bludgeoning damage for every 10 feet it was thrown. If the target is thrown at another creature, that creature must succeed on a {13} Dexterity saving throw or take the same damage and be knocked {prone}.",
        ],
      },
      {
        name: "Lightning Strike",
        entries: [
          "The kraken magically create a bolt of lightning, which can strike a target the kraken can see within 90 feet of it. The target must make a {18} Dexterity saving throw, taking 22 ( 4d10}) lightning damage on a failed save, or half as much damage on a successful one.",
        ],
      },
    ],
    legendary: [
      {
        name: "Tentacle Attack (Costs 2 Actions)",
        entries: ["The kraken makes one tentacle attack."],
      },
      {
        name: "Fling",
        entries: ["The kraken uses Fling."],
      },
      {
        name: "Ink Cloud (Costs 3 Actions)",
        entries: [
          "While underwater, the kraken expels an ink cloud in a 40-foot radius. The cloud spreads around corners, and that area is heavily obscured to creatures other than the kraken. Each creature other than the kraken that ends its turn there must succeed on a {18} Constitution saving throw, taking 11 ( 2d10}) poison damage on a failed save or half as much damage on a successful one. A strong current disperses the cloud, which otherwise disappears at the end of the kraken's next turn.",
        ],
      },
    ],
    traitTags: ["Amphibious"],
    senseTags: ["U"],
    actionTags: ["Multiattack", "Swallow", "Tentacles"],
    languageTags: ["AB", "CE", "CS", "I", "P", "TP"],
    damageTags: ["A", "B", "I", "L", "P"],
    miscTags: ["AOE", "MW", "RCH"],
    conditionInflict: ["blinded", "grappled", "prone", "restrained"],
    hasToken: true,
    hasFluff: true,
    hasFluffImages: true,
  },
  {
    name: "Koalinth",
    source: "GoS",
    page: 239,
    size: ["M"],
    type: {
      type: "humanoid",
      tags: ["goblinoid"],
    },
    alignment: ["L", "E"],
    ac: [
      {
        ac: 14,
        from: ["{@item scale mail|phb}"],
      },
    ],
    hp: {
      average: 16,
      formula: "3d8 + 3",
    },
    speed: {
      walk: 30,
      swim: 20,
    },
    str: 13,
    dex: 11,
    con: 12,
    int: 11,
    wis: 10,
    cha: 11,
    save: {
      dex: "+2",
    },
    skill: {
      athletics: "+3",
      perception: "+2",
    },
    senses: ["darkvision 60 ft."],
    passive: 12,
    languages: ["Common", "Goblin"],
    cr: "1/2",
    trait: [
      {
        name: "Amphibious",
        entries: ["The koalinth can breathe air and water."],
      },
      {
        name: "Martial Advantage",
        entries: [
          "Once per turn, the koalinth can deal an extra 7 ({@dice 2d6}) damage to a creature it hits with a weapon attack if that creature is within 5 feet of an ally of the koalinth that isn't {incapacitated}.",
        ],
      },
    ],
    action: [
      {
        name: "Trident",
        entries: [
          "{3} to hit, reach 5 ft. or range 20/60 ft., one target. 4 ( 1d6 + 1}) piercing damage, or 5 ( 1d8 + 1}) piercing damage if used with two hands to make a melee attack.",
        ],
      },
    ],
    attachedItems: ["trident|phb"],
    traitTags: ["Amphibious"],
    senseTags: ["D"],
    languageTags: ["C", "GO"],
    damageTags: ["P"],
    miscTags: ["MW", "RW", "THW"],
    hasToken: true,
    hasFluff: true,
    hasFluffImages: true,
  },
  {
    name: "Koalinth Sergeant",
    source: "GoS",
    page: 239,
    size: ["M"],
    type: {
      type: "humanoid",
      tags: ["goblinoid"],
    },
    alignment: ["L", "E"],
    ac: [
      {
        ac: 14,
        from: ["{@item scale mail|phb}"],
      },
    ],
    hp: {
      average: 33,
      formula: "6d8 + 6",
    },
    speed: {
      walk: 30,
      swim: 30,
    },
    str: 14,
    dex: 11,
    con: 12,
    int: 11,
    wis: 10,
    cha: 12,
    save: {
      dex: "+2",
      wis: "+2",
    },
    skill: {
      athletics: "+4",
      perception: "+2",
    },
    senses: ["darkvision 60 ft."],
    passive: 12,
    languages: ["Common", "Goblin"],
    cr: "2",
    trait: [
      {
        name: "Amphibious",
        entries: ["The koalinth can breathe air and water."],
      },
      {
        name: "Martial Advantage",
        entries: [
          "Once per turn, the sergeant can deal an extra 7 ({@dice 2d6}) damage to a creature it hits with a weapon attack if that creature is within 5 feet of an ally of the sergeant that isn't {incapacitated}.",
        ],
      },
    ],
    action: [
      {
        name: "Multiattack",
        entries: ["The sergeant makes two melee attacks with its trident."],
      },
      {
        name: "Trident",
        entries: [
          "{4} to hit, reach 5 ft. or range 20/60 ft., one target. 5 ( 1d6 + 2}) piercing damage, or 6 ( 1d8 + 2}) piercing damage if used with two hands to make a melee attack.",
        ],
      },
      {
        name: "Hooked Net",
        entries: [
          "{4} to hit, range 10/30 ft., one target. 4 ( 1d4 + 2}) piercing damage, and the target is {restrained}. A creature can use its action to make a {12} Strength check to free itself or another creature in a hooked net, ending the effect on a success. Dealing 5 slashing damage to the net (AC 12) frees the target without harming it and destroys the net.",
        ],
      },
    ],
    reaction: [
      {
        name: "Spear the Helpless (2/Day)",
        entries: [
          "Whenever a creature within 30 feet of the sergeant becomes {restrained}, the sergeant can move its speed toward the {restrained} creature. If the sergeant ends its move within reach of the {restrained} creature, it can make a melee attack against it.",
        ],
      },
    ],
    attachedItems: ["trident|phb"],
    traitTags: ["Amphibious"],
    senseTags: ["D"],
    actionTags: ["Multiattack"],
    languageTags: ["C", "GO"],
    damageTags: ["P", "S"],
    miscTags: ["MW", "RW", "THW"],
    conditionInflict: ["restrained"],
    hasToken: true,
    hasFluff: true,
    hasFluffImages: true,
  },
  {
    name: "Krell Grohlg",
    isNpc: true,
    isNamedCreature: true,
    source: "GoS",
    page: 92,
    _copy: {
      name: "Druid",
      source: "MM",
      _trait: {
        name: "Half-Orc",
        source: "PHB",
      },
      _mod: {
        "*": {
          mode: "replaceTxt",
          replace: "the druid",
          with: "Krell",
          flags: "i",
        },
        _: {
          mode: "replaceSpells",
          spells: {
            2: [
              {
                replace: "{animal messenger}",
                with: "{flaming sphere}",
              },
            ],
          },
        },
      },
    },
    alignment: ["C", "E"],
    str: 18,
    languages: ["Common", "Orc"],
    action: [
      {
        name: "Quarterstaff",
        entries: [
          "{6} to hit ({4} to hit with shillelagh), reach 5 ft., one target. 7 ( 1d6 + 4}) bludgeoning damage, 8 ( 1d8 + 4}) bludgeoning damage if wielded with two hands, or 6 ( 1d8 + 2}) bludgeoning damage with {shillelagh}.",
        ],
      },
    ],
    attachedItems: ["quarterstaff|phb"],
    senseTags: ["D"],
    languageTags: ["C", "O"],
    hasToken: true,
    hasFluffImages: true,
  },
  {
    name: "Kysh",
    isNpc: true,
    isNamedCreature: true,
    source: "GoS",
    page: 240,
    size: ["M"],
    type: {
      type: "humanoid",
      tags: ["triton"],
    },
    alignment: ["L", "G"],
    ac: [13],
    hp: {
      average: 27,
      formula: "5d8 + 5",
    },
    speed: {
      walk: 30,
      swim: 30,
    },
    str: 14,
    dex: 16,
    con: 12,
    int: 10,
    wis: 13,
    cha: 14,
    skill: {
      persuasion: "+4",
      survival: "+3",
    },
    senses: ["darkvision 60 ft."],
    passive: 11,
    languages: ["Common", "Primordial"],
    cr: "1",
    spellcasting: [
      {
        name: "Innate Spellcasting",
        headerEntries: [
          "Kysh's spellcasting ability is Charisma (spell save {12}, {4} to hit with spell attacks). He can cast the following spell, requiring only verbal components:",
        ],
        daily: {
          1: ["{fog cloud}"],
        },
        ability: "cha",
      },
    ],
    trait: [
      {
        name: "Amphibious",
        entries: ["Kysh can breathe air and water."],
      },
      {
        name: "Emissary of the Sea",
        entries: [
          "Kysh can communicate simple ideas with amphibious and water-breathing beasts. They understand the meaning of his words, but he cannot understand them in return.",
        ],
      },
    ],
    action: [
      {
        name: "Multiattack",
        entries: ["Kysh makes two melee attacks with his spear."],
      },
      {
        name: "Spear",
        entries: [
          "{4} to hit, reach 5 ft. or range 20/60 ft, one target. 5 ( 1d6 + 2}) piercing damage, or 6 ( 1d8 + 2}) piercing damage if used with two hands to make a melee attack.",
        ],
      },
    ],
    attachedItems: ["spear|phb"],
    traitTags: ["Amphibious"],
    senseTags: ["D"],
    actionTags: ["Multiattack"],
    languageTags: ["C", "P"],
    damageTags: ["P"],
    spellcastingTags: ["I"],
    miscTags: ["MW", "RW", "THW"],
    hasToken: true,
    hasFluff: true,
  },
  {
    name: "Living Iron Statue",
    source: "GoS",
    page: 241,
    size: ["M"],
    type: "construct",
    alignment: ["U"],
    ac: [
      {
        ac: 16,
        from: ["natural armor"],
      },
    ],
    hp: {
      average: 102,
      formula: "12d8 + 48",
    },
    speed: {
      walk: 20,
    },
    str: 16,
    dex: 14,
    con: 18,
    int: 6,
    wis: 10,
    cha: 5,
    senses: ["darkvision 60 ft."],
    passive: 10,
    immune: ["lightning", "poison"],
    vulnerable: ["acid"],
    conditionImmune: [
      "charmed",
      "exhaustion",
      "frightened",
      "paralyzed",
      "petrified",
      "poisoned",
    ],
    languages: ["understands the languages of its creator but can't speak"],
    cr: "5",
    trait: [
      {
        name: "Immutable Form",
        entries: [
          "The statue is immune to any spell or effect that would alter its form.",
        ],
      },
    ],
    action: [
      {
        name: "Multiattack",
        entries: [
          "The statue makes two attacks: one with its blade and one with its hammer.",
        ],
      },
      {
        name: "Blade",
        entries: [
          "{6} to hit, reach 5 ft., one target. 10 ( 2d6 + 3}) slashing damage.",
        ],
      },
      {
        name: "Hammer",
        entries: [
          "{6} to hit, reach 5 ft., one target. 10 ( 2d6 + 3}) bludgeoning damage, and the target is knocked {prone}.",
        ],
      },
      {
        name: "Whirl {@recharge 5}",
        entries: [
          "The statue can use its action to spin at the waist, targeting creatures of its choice within 10 feet of it. Each target must make a {13} Dexterity saving throw, taking 19 ( 3d10 + 3}) bludgeoning damage on a failed save, or half as much damage on a successful one.",
        ],
      },
    ],
    traitTags: ["Immutable Form"],
    senseTags: ["D"],
    actionTags: ["Multiattack"],
    languageTags: ["CS"],
    damageTags: ["B", "S"],
    miscTags: ["MW"],
    conditionInflict: ["prone"],
    hasToken: true,
    hasFluff: true,
  },
  {
    name: "Lizardfolk Commoner",
    source: "GoS",
    page: 241,
    size: ["M"],
    type: {
      type: "humanoid",
      tags: ["lizardfolk"],
    },
    alignment: ["N"],
    ac: [
      {
        ac: 13,
        from: ["natural armor"],
      },
    ],
    hp: {
      average: 16,
      formula: "3d8 + 3",
    },
    speed: {
      walk: 30,
      swim: 30,
    },
    str: 15,
    dex: 10,
    con: 12,
    int: 7,
    wis: 12,
    cha: 7,
    skill: {
      perception: "+3",
      stealth: "+2",
      survival: "+3",
    },
    passive: 13,
    languages: ["Draconic"],
    cr: "1/4",
    trait: [
      {
        name: "Hold Breath",
        entries: ["The lizardfolk can hold its breath for 15 minutes."],
      },
    ],
    action: [
      {
        name: "Bite",
        entries: [
          "{4} to hit, reach 5 ft., one target. 5 ( 1d6 + 2}) piercing damage.",
        ],
      },
    ],
    traitTags: ["Hold Breath"],
    languageTags: ["DR"],
    damageTags: ["P"],
    miscTags: ["MW"],
    hasToken: true,
    hasFluff: true,
  },
  {
    name: "Lizardfolk Render",
    source: "GoS",
    page: 241,
    otherSources: [
      {
        source: "SLW",
      },
      {
        source: "IMR",
      },
    ],
    size: ["L"],
    type: {
      type: "humanoid",
      tags: ["lizardfolk"],
    },
    alignment: ["N"],
    ac: [
      {
        ac: 15,
        from: ["natural armor"],
      },
    ],
    hp: {
      average: 52,
      formula: "7d10 + 14",
    },
    speed: {
      walk: 30,
      swim: 30,
    },
    str: 16,
    dex: 10,
    con: 14,
    int: 7,
    wis: 12,
    cha: 7,
    skill: {
      athletics: "+5",
      perception: "+3",
      survival: "+5",
    },
    passive: 13,
    languages: ["Draconic"],
    cr: "3",
    trait: [
      {
        name: "Blood Frenzy",
        entries: [
          "The render has advantage on melee attack rolls against any creature that doesn't have all its hit points.",
        ],
      },
      {
        name: "Hold Breath",
        entries: ["The render can hold its breath for 15 minutes."],
      },
    ],
    action: [
      {
        name: "Multiattack",
        entries: [
          "The render makes two attacks: one with its claws and one with its bite.",
        ],
      },
      {
        name: "Claws",
        entries: [
          "{5} to hit, reach 10 ft., one target. 12 ( 2d8 + 3}) slashing damage.",
        ],
      },
      {
        name: "Bite",
        entries: [
          "{5} to hit, reach 5 ft., one target. 8 ( 1d10 + 3}) piercing damage.",
        ],
      },
      {
        name: "Rend the Field {@recharge 5}",
        entries: [
          "The render makes a claw attack against each creature of its choice within 10 feet of it. A creature hit by this attack must succeed on a {13} Strength saving throw or be knocked {prone}.",
        ],
      },
    ],
    traitTags: ["Hold Breath"],
    actionTags: ["Multiattack"],
    languageTags: ["DR"],
    damageTags: ["P", "S"],
    miscTags: ["MW", "RCH"],
    conditionInflict: ["prone"],
    hasToken: true,
    hasFluff: true,
    hasFluffImages: true,
  },
  {
    name: "Lizardfolk Scaleshield",
    source: "GoS",
    page: 242,
    size: ["M"],
    type: {
      type: "humanoid",
      tags: ["lizardfolk"],
    },
    alignment: ["N"],
    ac: [
      {
        ac: 16,
        from: ["{@item scale mail|phb}", "{@item shield|phb}"],
      },
    ],
    hp: {
      average: 32,
      formula: "5d8 + 10",
    },
    speed: {
      walk: 30,
      swim: 30,
    },
    str: 15,
    dex: 10,
    con: 14,
    int: 7,
    wis: 12,
    cha: 7,
    skill: {
      athletics: "+4",
      perception: "+3",
      survival: "+5",
    },
    passive: 13,
    languages: ["Draconic"],
    cr: "1",
    trait: [
      {
        name: "Hold Breath",
        entries: ["The scaleshield can hold its breath for 15 minutes."],
      },
    ],
    action: [
      {
        name: "Multiattack",
        entries: [
          "The scaleshield makes two melee attacks, each one with a different weapon.",
        ],
      },
      {
        name: "Morningstar",
        entries: [
          "{4} to hit, reach 5 ft., one target. 6 ( 1d8 + 2}) piercing damage.",
        ],
      },
      {
        name: "Bite",
        entries: [
          "{4} to hit, reach 5 ft., one target. 5 ( 1d6 + 2}) piercing damage.",
        ],
      },
      {
        name: "Spiked Shield",
        entries: [
          "{4} to hit, reach 5 ft., one target. 5 ( 1d6 + 2}) piercing damage.",
        ],
      },
    ],
    reaction: [
      {
        name: "Shield Block",
        entries: [
          "If an ally within 5 feet of the scaleshield is hit by an attack, the scaleshield can reduce that attack's damage by half.",
        ],
      },
    ],
    attachedItems: ["morningstar|phb"],
    traitTags: ["Hold Breath"],
    actionTags: ["Multiattack"],
    languageTags: ["DR"],
    damageTags: ["P"],
    miscTags: ["MW"],
    hasToken: true,
    hasFluff: true,
  },
  {
    name: "Lizardfolk Subchief",
    source: "GoS",
    page: 242,
    otherSources: [
      {
        source: "SLW",
      },
    ],
    size: ["M"],
    type: {
      type: "humanoid",
      tags: ["lizardfolk"],
    },
    alignment: ["N"],
    ac: [
      {
        ac: 14,
        from: ["natural armor"],
      },
    ],
    hp: {
      average: 52,
      formula: "8d8 + 16",
    },
    speed: {
      walk: 30,
      swim: 30,
    },
    str: 14,
    dex: 12,
    con: 14,
    int: 10,
    wis: 16,
    cha: 12,
    save: {
      wis: "+5",
    },
    skill: {
      athletics: "+4",
      perception: "+5",
      survival: "+5",
    },
    passive: 15,
    languages: ["Draconic"],
    cr: "3",
    spellcasting: [
      {
        name: "Spellcasting",
        headerEntries: [
          "The subchief is a 5th-level spellcaster. Its spellcasting ability is Wisdom (spell save {13}, {5} to hit with spell attacks). It has the following cleric spells prepared:",
        ],
        spells: {
          0: {
            spells: [
              "{light}",
              "{sacred flame}",
              "{spare the dying}",
              "{thaumaturgy}",
            ],
          },
          1: {
            slots: 4,
            spells: ["{command}", "{Guiding Bolt}", "{purify food and drink}"],
          },
          2: {
            slots: 3,
            spells: ["{hold person}", "{lesser restoration}", "{silence}"],
          },
          3: {
            slots: 2,
            spells: ["{bestow curse}", "{dispel magic}"],
          },
        },
        ability: "wis",
      },
    ],
    trait: [
      {
        name: "Hold Breath",
        entries: ["The subchief can hold its breath for 15 minutes."],
      },
    ],
    action: [
      {
        name: "Tooth Dagger",
        entries: [
          "{4} to hit, reach 5 ft., one target. 4 ( 1d4 + 2}) piercing damage.",
        ],
      },
      {
        name: "Jaws of Semuanya {@recharge 5}",
        entries: [
          "The subchief invokes the primal magic of Semuanya, summoning a spectral maw around a target it can see within 60 feet of it. The target must make a {13} Dexterity saving throw, taking 22 ( 5d8}) piercing damage on a failed save, or half as much damage on a successful one. A creature that fails this saving throw is also {frightened} until the end of its next turn.",
        ],
      },
    ],
    traitTags: ["Hold Breath"],
    languageTags: ["DR"],
    damageTags: ["P"],
    damageTagsSpell: ["N", "R"],
    spellcastingTags: ["CC"],
    miscTags: ["MW"],
    conditionInflict: ["frightened"],
    conditionInflictSpell: ["deafened", "paralyzed", "prone"],
    hasToken: true,
    hasFluff: true,
  },
  {
    name: "Locathah",
    source: "GoS",
    page: 243,
    otherSources: [
      {
        source: "IMR",
      },
    ],
    size: ["M"],
    type: {
      type: "humanoid",
      tags: ["locathah"],
    },
    alignment: ["N"],
    ac: [
      {
        ac: 13,
        from: ["natural armor"],
      },
    ],
    hp: {
      average: 22,
      formula: "4d8 + 4",
    },
    speed: {
      walk: 30,
      swim: 30,
    },
    str: 13,
    dex: 12,
    con: 12,
    int: 11,
    wis: 10,
    cha: 11,
    save: {
      dex: "+3",
    },
    skill: {
      athletics: "+3",
      perception: "+2",
    },
    passive: 12,
    languages: ["Aquan", "Common"],
    cr: "1/2",
    trait: [
      {
        name: "Leviathan Will",
        entries: [
          "The locathah has advantage on saving throws against being {charmed}, {frightened}, {paralyzed}, {poisoned}, {stunned}, or put to sleep.",
        ],
      },
      {
        name: "Limited Amphibiousness",
        entries: [
          "The locathah can breathe air and water, but it needs to be submerged at least once every 4 hours to avoid suffocating.",
        ],
      },
    ],
    action: [
      {
        name: "Multiattack",
        entries: ["The locathah makes two melee attacks with its spear."],
      },
      {
        name: "Spear",
        entries: [
          "{3} to hit, reach 5 ft. or range 20/60 ft., one target. 4 ( 1d6 + 1}) piercing damage, or 5 ( 1d8 + 1}) piercing damage if used with two hands.",
        ],
      },
    ],
    attachedItems: ["spear|phb"],
    actionTags: ["Multiattack"],
    languageTags: ["AQ", "C"],
    damageTags: ["P"],
    miscTags: ["MW", "RW", "THW"],
    hasToken: true,
    hasFluff: true,
    hasFluffImages: true,
  },
  {
    name: "Locathah Hunter",
    source: "GoS",
    page: 243,
    size: ["M"],
    type: {
      type: "humanoid",
      tags: ["locathah"],
    },
    alignment: ["N"],
    ac: [
      {
        ac: 14,
        from: ["natural armor"],
      },
    ],
    hp: {
      average: 33,
      formula: "6d8 + 6",
    },
    speed: {
      walk: 30,
      swim: 30,
    },
    str: 13,
    dex: 14,
    con: 12,
    int: 11,
    wis: 14,
    cha: 11,
    save: {
      dex: "+4",
      wis: "+4",
    },
    skill: {
      athletics: "+3",
      perception: "+4",
    },
    passive: 14,
    languages: ["Aquan", "Common"],
    cr: "2",
    trait: [
      {
        name: "Leviathan Will",
        entries: [
          "The hunter has advantage on saving throws against spells and effects that control its actions.",
        ],
      },
      {
        name: "Limited Amphibiousness",
        entries: [
          "The hunter can breathe air and water, but it needs to be submerged at least once every 4 hours to avoid suffocating.",
        ],
      },
    ],
    action: [
      {
        name: "Multiattack",
        entries: ["The hunter makes two attacks with its envenomed crossbow."],
      },
      {
        name: "Envenomed Crossbow",
        entries: [
          "{4} to hit, range 80/320 ft., one target. 11 ( 2d8 + 2}) piercing damage, and the target must succeed on a {12} Constitution saving throw or be {poisoned} until the end of its next turn.",
        ],
      },
      {
        name: "Club",
        entries: [
          "{3} to hit, reach 5 ft., one target. 4 ( 1d6 + 1}) bludgeoning damage.",
        ],
      },
    ],
    attachedItems: ["club|phb"],
    actionTags: ["Multiattack"],
    languageTags: ["AQ", "C"],
    damageTags: ["B", "P"],
    miscTags: ["MW", "RW"],
    conditionInflict: ["poisoned"],
    hasToken: true,
    hasFluff: true,
    hasFluffImages: true,
  },
  {
    name: "Master Refrum",
    isNpc: true,
    isNamedCreature: true,
    source: "GoS",
    page: 165,
    _copy: {
      name: "Priest",
      source: "MM",
      _mod: {
        "*": {
          mode: "replaceTxt",
          replace: "the priest",
          with: "Refrum",
          flags: "i",
        },
      },
    },
    type: {
      type: "humanoid",
      tags: ["human"],
    },
    alignment: ["L", "G"],
    hasToken: true,
    hasFluffImages: true,
  },
  {
    name: "Maw of Sekolah",
    isNpc: true,
    isNamedCreature: true,
    source: "GoS",
    page: 244,
    size: ["H"],
    type: "monstrosity",
    alignment: ["N", "E"],
    ac: [
      {
        ac: 12,
        from: ["natural armor"],
      },
    ],
    hp: {
      average: 114,
      formula: "12d12 + 36",
    },
    speed: {
      walk: 0,
      swim: 50,
    },
    str: 21,
    dex: 12,
    con: 17,
    int: 2,
    wis: 14,
    cha: 7,
    save: {
      str: "+8",
      con: "+6",
    },
    skill: {
      athletics: "+8",
      perception: "+5",
    },
    senses: ["darkvision 120 ft."],
    passive: 15,
    languages: ["Sahuagin", "telepathy 100 ft."],
    cr: "7",
    trait: [
      {
        name: "Legendary Resistance (2/Day)",
        entries: [
          "If the maw of Sekolah fails a saving throw, it can choose to succeed instead.",
        ],
      },
      {
        name: "Water Breathing",
        entries: ["The maw of Sekolah can breathe only underwater."],
      },
    ],
    action: [
      {
        name: "Multiattack",
        entries: [
          "The maw of Sekolah makes one attack with its bite and one attack with its tail smash.",
        ],
      },
      {
        name: "Bite",
        entries: [
          "{8} to hit, reach 10 ft., one target. 16 ( 2d10 + 5}) piercing damage.",
        ],
      },
      {
        name: "Tail Smash",
        entries: [
          "{8} to hit, reach 10 ft., one target. 9 ( 1d8 + 5}) bludgeoning damage.",
        ],
      },
    ],
    legendary: [
      {
        name: "Detect",
        entries: ["The maw of Sekolah makes a Wisdom (Perception) check."],
      },
      {
        name: "Speed of Sekolah",
        entries: ["The maw of Sekolah moves up to its speed."],
      },
      {
        name: "Feed (Costs 2 Actions)",
        entries: [
          "The ferocious spirit of Sekolah flashes through the water, tearing through the foes of the maw of Sekolah. Each creature of the maw's choosing within 60 feet of it must make a {16} Dexterity saving throw, taking 7 ( 2d6}) slashing damage on a failed save, or half as much damage on a successful one.",
        ],
      },
    ],
    traitTags: ["Legendary Resistances", "Water Breathing"],
    senseTags: ["SD"],
    actionTags: ["Multiattack"],
    languageTags: ["OTH", "TP"],
    damageTags: ["B", "P", "S"],
    miscTags: ["MW", "RCH"],
    hasToken: true,
    hasFluff: true,
  },
  {
    name: "Merfolk Salvager",
    source: "GoS",
    page: 244,
    size: ["M"],
    type: {
      type: "humanoid",
      tags: ["merfolk"],
    },
    alignment: ["N"],
    ac: [12],
    hp: {
      average: 22,
      formula: "4d8 + 4",
    },
    speed: {
      walk: 10,
      swim: 40,
    },
    str: 12,
    dex: 14,
    con: 12,
    int: 11,
    wis: 10,
    cha: 13,
    save: {
      dex: "+4",
    },
    skill: {
      athletics: "+3",
      perception: "+2",
    },
    passive: 12,
    languages: ["Aquan", "Common"],
    cr: "1",
    trait: [
      {
        name: "Amphibious",
        entries: ["The salvager can breathe air and water."],
      },
    ],
    action: [
      {
        name: "Multiattack",
        entries: ["The salvager makes two attacks with its coral rapier."],
      },
      {
        name: "Coral Rapier",
        entries: [
          "{@atk m} {4} to hit, reach 5 ft., one target. 6 ( 1d8 + 2}) piercing damage.",
        ],
      },
      {
        name: "Inject Toxin (2/Day)",
        entries: [
          "{@atk m} {4} to hit, reach 5 ft., one target. 6 ( 1d8 + 2}) piercing damage, and the creature must succeed on a {12} Constitution saving throw or be {paralyzed} until the end of its next turn.",
        ],
      },
    ],
    traitTags: ["Amphibious"],
    actionTags: ["Multiattack"],
    languageTags: ["AQ", "C"],
    damageTags: ["P"],
    conditionInflict: ["paralyzed"],
    hasToken: true,
    hasFluff: true,
  },
  {
    name: "Merfolk Scout",
    source: "GoS",
    page: 216,
    _copy: {
      name: "Scout",
      source: "MM",
      _trait: {
        name: "Merfolk",
        source: "DMG",
      },
      _mod: {
        action: {
          mode: "removeArr",
          names: "Longbow",
        },
      },
    },
    type: {
      type: "humanoid",
      tags: ["merfolk"],
    },
    alignment: ["C", "E"],
    traitTags: ["Amphibious", "Keen Senses"],
    languageTags: ["AQ", "C", "X"],
    miscTags: ["MW"],
    hasToken: true,
  },
  {
    name: "Minotaur Living Crystal Statue",
    source: "GoS",
    page: 245,
    size: ["L"],
    type: "construct",
    alignment: ["U"],
    ac: [
      {
        ac: 15,
        from: ["natural armor"],
      },
    ],
    hp: {
      average: 136,
      formula: "16d10 + 48",
    },
    speed: {
      walk: 30,
    },
    str: 18,
    dex: 9,
    con: 16,
    int: 6,
    wis: 10,
    cha: 5,
    senses: ["darkvision 60 ft."],
    passive: 10,
    immune: ["lightning", "poison"],
    vulnerable: ["force"],
    conditionImmune: [
      "charmed",
      "exhaustion",
      "frightened",
      "paralyzed",
      "petrified",
      "poisoned",
    ],
    languages: ["understands the languages of its creator but can't speak"],
    cr: "6",
    trait: [
      {
        name: "Immutable Form",
        entries: [
          "The statue is immune to any spell or effect that would alter its form.",
        ],
      },
    ],
    action: [
      {
        name: "Multiattack",
        entries: [
          "The statue makes two attacks: one with its Greataxe and one gore attack.",
        ],
      },
      {
        name: "Greataxe",
        entries: [
          "{7} to hit, reach 5 ft., one target. 17 ( 2d12 + 4}) slashing damage.",
        ],
      },
      {
        name: "Gore",
        entries: [
          "{7} to hit, reach 5 ft., one target. 8 ( 1d8 + 4}) piercing damage.",
        ],
      },
    ],
    reaction: [
      {
        name: "Flying Shards",
        entries: [
          "In response to a creature hitting the statue with a melee weapon attack, the statue deals 11 ( 2d10}) piercing damage to the attacker.",
        ],
      },
    ],
    attachedItems: ["Greataxe|phb"],
    traitTags: ["Immutable Form"],
    senseTags: ["D"],
    actionTags: ["Multiattack"],
    languageTags: ["CS"],
    damageTags: ["P", "S"],
    miscTags: ["MW"],
    hasToken: true,
    hasFluff: true,
  },
  {
    name: "Monstrous Peryton",
    source: "GoS",
    page: 245,
    size: ["L"],
    type: "monstrosity",
    alignment: ["C", "E"],
    ac: [
      {
        ac: 14,
        from: ["natural armor"],
      },
    ],
    hp: {
      average: 144,
      formula: "17d10 + 51",
    },
    speed: {
      walk: 20,
      fly: 60,
    },
    str: 19,
    dex: 14,
    con: 16,
    int: 9,
    wis: 14,
    cha: 10,
    save: {
      str: "+8",
      dex: "+6",
      wis: "+6",
    },
    skill: {
      perception: "+6",
    },
    senses: ["darkvision 60 ft."],
    passive: 16,
    languages: ["understands Common and Elvish but can't speak"],
    cr: "11",
    trait: [
      {
        name: "Flyby",
        entries: [
          "The peryton doesn't provoke opportunity attacks when it flies out of an enemy's reach.",
        ],
      },
      {
        name: "Keen Sight and Smell",
        entries: [
          "The peryton has advantage on Wisdom (Perception) checks that rely on sight or smell.",
        ],
      },
      {
        name: "Legendary Resistance (3/Day)",
        entries: [
          "If the peryton fails a saving throw, it can choose to succeed instead.",
        ],
      },
    ],
    action: [
      {
        name: "Multiattack",
        entries: [
          "The peryton makes two attacks: one with its gore and one with its talons.",
        ],
      },
      {
        name: "Gore",
        entries: [
          "{9} to hit, reach 5 ft., one target. 12 ( 2d6 + 5}) piercing damage.",
        ],
      },
      {
        name: "Talons",
        entries: [
          "{9} to hit, reach 5 ft., one target. 16 ( 2d10 + 5}) slashing damage.",
        ],
      },
      {
        name: "Warp Shadow",
        entries: [
          "The peryton chooses up to three creatures within 60 feet of it that it can see. Each creature must succeed on a {14} Wisdom saving throw or become cursed. While cursed, whenever the creature makes an attack roll, an ability check, or a saving throw, it must roll a {@dice d4} and subtract that number from the roll. A cursed creature can repeat this saving throw at the end of each of its turns, ending the effect on itself with a success. A creature that succeeds on this saving throw is immune to this peryton's Warp Shadow for 24 hours.",
        ],
      },
    ],
    legendary: [
      {
        name: "Detect",
        entries: ["The peryton makes a Wisdom (Perception) check."],
      },
      {
        name: "Talons Attack",
        entries: ["The peryton makes one attack with its talons."],
      },
      {
        name: "Dive Attack (Costs 2 Actions)",
        entries: [
          "The peryton moves up to its speed toward one target of its choosing. It then makes a gore attack that deals an extra 9 ( 2d8}) piercing damage on a hit.",
        ],
      },
    ],
    traitTags: ["Flyby", "Keen Senses", "Legendary Resistances"],
    senseTags: ["D"],
    actionTags: ["Multiattack"],
    languageTags: ["C", "CS", "E"],
    damageTags: ["P", "S"],
    miscTags: ["MW"],
    hasToken: true,
    hasFluff: true,
    hasFluffImages: true,
  },
  {
    name: "Mr. Dory",
    isNpc: true,
    isNamedCreature: true,
    source: "GoS",
    page: 246,
    size: ["M"],
    type: "aberration",
    alignment: ["C", "E"],
    ac: [
      {
        ac: 18,
        from: [
          "{@item studded Leather Armor|phb|studded leather}",
          "{@item shield|phb}",
        ],
      },
    ],
    hp: {
      average: 170,
      formula: "20d8 + 80",
    },
    speed: {
      walk: 30,
    },
    str: 13,
    dex: 20,
    con: 19,
    int: 14,
    wis: 14,
    cha: 16,
    save: {
      con: "+8",
      wis: "+6",
    },
    skill: {
      athletics: "+5",
      perception: "+6",
      stealth: "+9",
    },
    senses: ["darkvision 60 ft."],
    passive: 16,
    immune: ["necrotic"],
    languages: ["Abyssal", "Common", "Deep Speech", "telepathy 60 ft."],
    cr: "10",
    spellcasting: [
      {
        name: "Innate Spellcasting",
        headerEntries: [
          "Mr. Dory's innate spellcasting ability is Charisma (save {15}, {7} to hit with spell attacks). Mr. Dory can innately cast the following spells, requiring no material components:",
        ],
        will: [
          "{detect magic}",
          "{detect thoughts}",
          "{invisibility} (self only)",
        ],
        daily: {
          "2e": ["{fear}", "{fireball}", "{fly}"],
          "1e": ["{Cloudkill}", "{etherealness}"],
        },
        ability: "cha",
      },
    ],
    trait: [
      {
        name: "Magic Resistance",
        entries: [
          "Mr. Dory has advantage on saving throws against spells and other magical effects.",
        ],
      },
      {
        name: "Water Dependency",
        entries: [
          "Mr. Dory takes 6 ( 1d12}) acid damage at the end of every hour he goes without exposure to water.",
        ],
      },
    ],
    action: [
      {
        name: "Multiattack",
        entries: ["Mr. Dory makes three attacks with his rapier."],
      },
      {
        name: "Rapier",
        entries: [
          "{9} to hit, reach 5 ft., one target. 9 ( 1d8 + 5}) piercing damage and 7 ( 2d6}) necrotic damage.",
        ],
      },
      {
        name: "Eye of Corruption {@recharge 5}",
        entries: [
          "Mr. Dory glares at a creature he can see within 30 feet of him. The target must make a {15} Constitution saving throw. On a failed save, it takes 27 ( 5d10}) necrotic damage and 27 ( 5d10}) poison damage and then gains vulnerability to both necrotic and poison damage for 1 minute. On a successful save, it takes half damage and does not gain the vulnerabilities.",
        ],
      },
    ],
    attachedItems: ["rapier|phb"],
    traitTags: ["Magic Resistance"],
    senseTags: ["D"],
    actionTags: ["Multiattack"],
    languageTags: ["AB", "C", "DS", "TP"],
    damageTags: ["A", "I", "N", "P"],
    damageTagsSpell: ["F", "I", "O"],
    spellcastingTags: ["I"],
    miscTags: ["MW"],
    hasToken: true,
    hasFluff: true,
    hasFluffImages: true,
  },
  {
    name: "Oceanus",
    isNpc: true,
    isNamedCreature: true,
    source: "GoS",
    page: 246,
    size: ["M"],
    type: {
      type: "humanoid",
      tags: ["elf"],
    },
    alignment: ["N", "G"],
    ac: [
      {
        ac: 12,
        from: ["{@item Leather Armor|phb}"],
      },
    ],
    hp: {
      average: 30,
      formula: "4d8 + 12",
    },
    speed: {
      walk: 30,
      swim: 30,
    },
    str: 15,
    dex: 12,
    con: 16,
    int: 11,
    wis: 12,
    cha: 10,
    save: {
      con: "+5",
    },
    skill: {
      athletics: "+4",
      perception: "+3",
    },
    senses: ["darkvision 60 ft."],
    passive: 13,
    languages: ["Aquan", "Elvish"],
    cr: "1/2",
    trait: [
      {
        name: "Amphibious",
        entries: ["Oceanus can breathe air and water."],
      },
      {
        name: "Friend of the Sea",
        entries: [
          "Using gestures and sounds, Oceanus can communicate simple ideas with any beast that has an innate swimming speed.",
        ],
      },
    ],
    action: [
      {
        name: "Trident",
        entries: [
          "{4} to hit, reach 5 ft. or range 20/60 ft., one target. 5 ( 1d6 + 2}) piercing damage, or 6 ( 1d8 + 2}) piercing damage if used with two hands to make a melee attack.",
        ],
      },
      {
        name: "Light Crossbow",
        entries: [
          "{3} to hit, range 80/320 ft., one target. 5 ( 1d8 + 1}) piercing damage.",
        ],
      },
    ],
    attachedItems: ["light crossbow|phb", "trident|phb"],
    traitTags: ["Amphibious"],
    senseTags: ["D"],
    languageTags: ["AQ", "E"],
    damageTags: ["P"],
    miscTags: ["MW", "RNG", "RW", "THW"],
    hasToken: true,
    hasFluff: true,
  },
  {
    name: "Othokent",
    isNpc: true,
    isNamedCreature: true,
    source: "GoS",
    page: 81,
    _copy: {
      name: "Lizard Queen",
      source: "MM",
      _mod: {
        "*": {
          mode: "replaceTxt",
          replace: "the lizardfolk",
          with: "Othokent",
          flags: "i",
        },
      },
    },
    alignment: ["L", "N"],
    languages: ["Common", "Abyssal", "Draconic"],
    languageTags: ["AB", "C", "DR"],
    hasToken: true,
  },
  {
    name: "Pirate Bosun",
    source: "GoS",
    page: 247,
    size: ["M"],
    type: {
      type: "humanoid",
      tags: ["any race"],
    },
    alignment: ["A"],
    ac: [
      {
        ac: 12,
        from: ["{@item studded Leather Armor|phb|studded leather}"],
      },
    ],
    hp: {
      average: 27,
      formula: "5d8 + 5",
    },
    speed: {
      walk: 30,
    },
    str: 16,
    dex: 11,
    con: 13,
    int: 11,
    wis: 10,
    cha: 13,
    skill: {
      athletics: "+5",
      intimidation: "+3",
    },
    passive: 10,
    languages: ["any one language (usually Common)"],
    cr: "1/2",
    trait: [
      {
        name: "Cargo Hauler",
        entries: ["The bosun has advantage on Strength checks."],
      },
      {
        name: "Sea Legs",
        entries: [
          "The bosun has advantage on ability checks and saving throws to resist being knocked {prone}.",
        ],
      },
    ],
    action: [
      {
        name: "Light Hammer",
        entries: [
          "{5} to hit, reach 5 ft. or range 20/60 ft., one target. 5 ( 1d4 + 3}) bludgeoning damage.",
        ],
      },
      {
        name: "Hook",
        entries: [
          "{5} to hit, reach 5 ft., one target. 7 ( 1d8 + 3}) piercing damage, and the target is {grappled} (escape {13}).",
        ],
      },
    ],
    attachedItems: ["light hammer|phb"],
    languageTags: ["C", "X"],
    damageTags: ["B", "P"],
    miscTags: ["MW", "RW", "THW"],
    conditionInflict: ["grappled"],
    hasToken: true,
    hasFluff: true,
  },
  {
    name: "Pirate Captain",
    source: "GoS",
    page: 247,
    size: ["M"],
    type: {
      type: "humanoid",
      tags: ["any race"],
    },
    alignment: ["A"],
    ac: [
      {
        ac: 14,
        from: ["{@item studded Leather Armor|phb|studded leather}"],
      },
    ],
    hp: {
      average: 45,
      formula: "7d8 + 14",
    },
    speed: {
      walk: 30,
    },
    str: 16,
    dex: 14,
    con: 14,
    int: 11,
    wis: 10,
    cha: 14,
    skill: {
      athletics: "+5",
      intimidation: "+4",
    },
    passive: 10,
    languages: ["any one language (usually Common)"],
    cr: "2",
    trait: [
      {
        name: "Flourish",
        entries: [
          "The captain adds its Charisma modifier to the damage roll for its longsword attacks (included in the attack).",
        ],
      },
      {
        name: "Sea Legs",
        entries: [
          "The captain has advantage on ability checks and saving throws to resist being knocked {prone}.",
        ],
      },
    ],
    action: [
      {
        name: "Multiattack",
        entries: [
          "The captain makes two attacks: one with its hand crossbow and one with its longsword.",
        ],
      },
      {
        name: "Hand Crossbow",
        entries: [
          "{4} to hit, range 30/120 ft., one target. 5 ( 1d6 + 2}) piercing damage.",
        ],
      },
      {
        name: "Longsword",
        entries: [
          "{5} to hit, reach 5 ft., one target. 9 ( 1d8 + 5}) slashing damage, or 10 ( 1d10 + 5}) slashing damage if used with two hands.",
        ],
      },
    ],
    reaction: [
      {
        name: "Shape Up, Ye Dog (2/Day)",
        entries: [
          "Whenever a friendly creature within 30 feet of the captain that can hear it misses with an attack, the captain can yell perilous threats to allow that creature to reroll the attack roll.",
        ],
      },
    ],
    attachedItems: ["hand crossbow|phb", "longsword|phb"],
    actionTags: ["Multiattack"],
    languageTags: ["C", "X"],
    damageTags: ["P", "S"],
    miscTags: ["MW", "RNG", "RW"],
    hasToken: true,
    hasFluff: true,
  },
  {
    name: "Pirate Deck Wizard",
    source: "GoS",
    page: 248,
    size: ["M"],
    type: {
      type: "humanoid",
      tags: ["any race"],
    },
    alignment: ["A"],
    ac: [
      12,
      {
        ac: 15,
        condition: "with {mage armor}",
        braces: true,
      },
    ],
    hp: {
      average: 32,
      formula: "5d8 + 10",
    },
    speed: {
      walk: 30,
    },
    str: 10,
    dex: 14,
    con: 14,
    int: 16,
    wis: 13,
    cha: 11,
    skill: {
      arcana: "+5",
      perception: "+3",
    },
    passive: 13,
    languages: ["any one language (usually Common)"],
    cr: "1",
    spellcasting: [
      {
        name: "Spellcasting",
        headerEntries: [
          "The Deck wizard is a 4th-level spellcaster. Its spellcasting ability is Intelligence (spell save {13}, {5} to hit with spell attacks). It has the following wizard spells prepared:",
        ],
        spells: {
          0: {
            spells: [
              "{friends}",
              "{mage hand}",
              "{prestidigitation}",
              "{Ray of Frost}",
            ],
          },
          1: {
            slots: 4,
            spells: [
              "{disguise self}",
              "{fog cloud}",
              "{mage armor}",
              "{witch bolt}",
            ],
          },
          2: {
            slots: 3,
            spells: ["{Gust of Wind}", "{Melf's acid arrow}", "{misty step}"],
          },
        },
        ability: "int",
      },
    ],
    trait: [
      {
        name: "Sea Legs",
        entries: [
          "The Deck wizard has advantage on ability checks and saving throws to resist being knocked {prone}.",
        ],
      },
    ],
    action: [
      {
        name: "Quarterstaff",
        entries: [
          "{2} to hit, reach 5 ft., one target. 3 ( 1d6}) bludgeoning damage.",
        ],
      },
    ],
    attachedItems: ["quarterstaff|phb"],
    languageTags: ["C", "X"],
    damageTags: ["B"],
    damageTagsSpell: ["A", "C", "L"],
    spellcastingTags: ["CW"],
    miscTags: ["MW"],
    hasToken: true,
    hasFluff: true,
  },
  {
    name: "Pirate First Mate",
    source: "GoS",
    page: 248,
    size: ["M"],
    type: {
      type: "humanoid",
      tags: ["any race"],
    },
    alignment: ["A"],
    ac: [
      {
        ac: 16,
        from: ["{@item chain mail|phb}"],
      },
    ],
    hp: {
      average: 26,
      formula: "4d8 + 8",
    },
    speed: {
      walk: 30,
    },
    str: 14,
    dex: 11,
    con: 14,
    int: 11,
    wis: 10,
    cha: 13,
    skill: {
      athletics: "+4",
      intimidation: "+3",
    },
    passive: 10,
    languages: ["any one language (usually Common)"],
    cr: "1",
    trait: [
      {
        name: "Sea Legs",
        entries: [
          "The first mate has advantage on ability checks and saving throws to resist being knocked {prone}.",
        ],
      },
    ],
    action: [
      {
        name: "Multiattack",
        entries: ["The first mate makes two attacks with its longsword."],
      },
      {
        name: "Longsword",
        entries: [
          "{4} to hit, reach 5 ft., one target. 6 ( 1d8 + 2}) slashing damage, or 7 ( 1d10 + 2}) slashing damage if used with two hands. If the target is a creature, the first mate can choose to deal no damage with the attack to disarm the target. The target must succeed on a {14} Strength saving throw or drop one item it is holding on the ground.",
        ],
      },
    ],
    attachedItems: ["longsword|phb"],
    actionTags: ["Multiattack"],
    languageTags: ["C", "X"],
    damageTags: ["S"],
    miscTags: ["MW"],
    hasToken: true,
    hasFluff: true,
  },
  {
    name: "Rip Tide Priest",
    source: "GoS",
    page: 248,
    size: ["M"],
    type: {
      type: "humanoid",
      tags: ["human"],
    },
    alignment: ["N", "E"],
    ac: [
      {
        ac: 13,
        from: ["{@item chain shirt|phb}"],
      },
    ],
    hp: {
      average: 52,
      formula: "8d8 + 16",
    },
    speed: {
      walk: 30,
    },
    str: 15,
    dex: 11,
    con: 14,
    int: 10,
    wis: 11,
    cha: 16,
    skill: {
      deception: "+5",
      religion: "+2",
      stealth: "+2",
    },
    passive: 10,
    languages: ["Aquan", "Common"],
    cr: "2",
    spellcasting: [
      {
        name: "Spellcasting",
        headerEntries: [
          "The priest is a 5th-level spellcaster. Its spellcasting ability is Charisma (spell save {13}, {5} to hit with spell attacks). It knows the following sorcerer spells:",
        ],
        spells: {
          0: {
            spells: [
              "{chill touch}",
              "{mage hand}",
              "{minor illusion}",
              "{prestidigitation}",
              "{Ray of Frost}",
            ],
          },
          1: {
            slots: 4,
            spells: ["{expeditious retreat}", "{Magic Missile}", "{shield}"],
          },
          2: {
            slots: 3,
            spells: ["{blur}", "{hold person}"],
          },
          3: {
            slots: 2,
            spells: ["{sleet storm}"],
          },
        },
        ability: "cha",
      },
    ],
    action: [
      {
        name: "Quarterstaff",
        entries: [
          "{4} to hit, reach 5 ft., one target. 6 ( 1d8 + 2}) bludgeoning damage.",
        ],
      },
    ],
    attachedItems: ["quarterstaff|phb"],
    languageTags: ["AQ", "C"],
    damageTags: ["B"],
    damageTagsSpell: ["C", "N", "O"],
    spellcastingTags: ["CS"],
    miscTags: ["MW"],
    hasToken: true,
    hasFluff: true,
  },
  {
    name: "Sahuagin Blademaster",
    source: "GoS",
    page: 249,
    otherSources: [
      {
        source: "SDW",
      },
      {
        source: "LR",
      },
    ],
    size: ["M"],
    type: {
      type: "humanoid",
      tags: ["sahuagin"],
    },
    alignment: ["L", "E"],
    ac: [
      {
        ac: 20,
        from: ["{@item Plate Armor|phb}", "{@item shield|phb}"],
      },
    ],
    hp: {
      average: 97,
      formula: "15d8 + 30",
    },
    speed: {
      walk: 30,
      swim: 40,
    },
    str: 16,
    dex: 12,
    con: 14,
    int: 12,
    wis: 11,
    cha: 12,
    save: {
      str: "+6",
      con: "+5",
    },
    skill: {
      athletics: "+6",
      intimidation: "+4",
    },
    senses: ["darkvision 120 ft."],
    passive: 10,
    languages: ["Sahuagin"],
    cr: "6",
    trait: [
      {
        name: "Blood Frenzy",
        entries: [
          "The blademaster has advantage on melee attack rolls against any creature that doesn't have all its hit points.",
        ],
      },
      {
        name: "Limited Amphibiousness",
        entries: [
          "The blademaster can breathe air and water, but it needs to be submerged at least once every 4 hours to avoid suffocating.",
        ],
      },
      {
        name: "Shark Telepathy",
        entries: [
          "The blademaster can magically command any shark within 120 feet of it, using a limited telepathy.",
        ],
      },
    ],
    action: [
      {
        name: "Multiattack",
        entries: [
          "The blademaster makes three attacks with its wavecutter blade, or one attack with its bite and two with its claws.",
        ],
      },
      {
        name: "Wavecutter Blade",
        entries: [
          "{6} to hit, reach 5 ft., one target. 12 ( 2d8 + 3}) slashing damage.",
        ],
      },
      {
        name: "Bite",
        entries: [
          "{6} to hit, reach 5 ft., one target. 8 ( 1d10 + 3}) piercing damage.",
        ],
      },
      {
        name: "Claws",
        entries: [
          "{6} to hit, reach 5 ft., one target. 7 ( 1d8 + 3}) slashing damage.",
        ],
      },
    ],
    senseTags: ["SD"],
    actionTags: ["Multiattack"],
    languageTags: ["OTH"],
    damageTags: ["P", "S"],
    miscTags: ["MW"],
    hasToken: true,
    hasFluff: true,
  },
  {
    name: "Sahuagin Champion",
    source: "GoS",
    page: 249,
    size: ["M"],
    type: {
      type: "humanoid",
      tags: ["sahuagin"],
    },
    alignment: ["L", "E"],
    ac: [
      {
        ac: 16,
        from: ["natural armor"],
      },
    ],
    hp: {
      average: 71,
      formula: "13d8 + 13",
    },
    speed: {
      walk: 30,
      swim: 40,
    },
    str: 16,
    dex: 14,
    con: 12,
    int: 12,
    wis: 13,
    cha: 9,
    skill: {
      perception: "+5",
    },
    senses: ["darkvision 120 ft."],
    passive: 15,
    languages: ["Sahuagin"],
    cr: "3",
    trait: [
      {
        name: "Blood Frenzy",
        entries: [
          "The champion has advantage on melee attack rolls against any creature that doesn't have all its hit points.",
        ],
      },
      {
        name: "Limited Amphibiousness",
        entries: [
          "The champion can breathe air and water, but it needs to be submerged at least once every 4 hours to avoid suffocating.",
        ],
      },
      {
        name: "Shark Telepathy",
        entries: [
          "The champion can magically command any shark within 120 feet of it, using a limited telepathy.",
        ],
      },
    ],
    action: [
      {
        name: "Multiattack",
        entries: [
          "The champion makes three attacks with its spear, or one attack with its bite and two with its claws.",
        ],
      },
      {
        name: "Spear",
        entries: [
          "{5} to hit, reach 5 ft. or range 20/60 ft., one target. 6 ( 1d6 + 3}) piercing damage, or 7 ( 1d8 + 3}) piercing damage if used with two hands to make a melee attack.",
        ],
      },
      {
        name: "Bite",
        entries: [
          "{5} to hit, reach 5 ft., one target. 5 ( 1d4 + 3}) piercing damage.",
        ],
      },
      {
        name: "Claws",
        entries: [
          "{5} to hit, reach 5 ft., one target. 6 ( 1d6 + 3}) slashing damage.",
        ],
      },
    ],
    attachedItems: ["spear|phb"],
    senseTags: ["SD"],
    actionTags: ["Multiattack"],
    languageTags: ["OTH"],
    damageTags: ["P", "S"],
    miscTags: ["MW", "RW", "THW"],
    hasToken: true,
    hasFluff: true,
  },
  {
    name: "Sahuagin Coral Smasher",
    source: "GoS",
    page: 249,
    size: ["M"],
    type: {
      type: "humanoid",
      tags: ["sahuagin"],
    },
    alignment: ["L", "E"],
    ac: [
      {
        ac: 14,
        from: ["natural armor"],
      },
    ],
    hp: {
      average: 33,
      formula: "6d8 + 6",
    },
    speed: {
      walk: 30,
      swim: 40,
    },
    str: 16,
    dex: 12,
    con: 12,
    int: 12,
    wis: 13,
    cha: 9,
    skill: {
      perception: "+5",
    },
    senses: ["darkvision 120 ft."],
    passive: 15,
    languages: ["Sahuagin"],
    cr: "1",
    trait: [
      {
        name: "Blood Frenzy",
        entries: [
          "The coral smasher has advantage on melee attack rolls against any creature that doesn't have all its hit points.",
        ],
      },
      {
        name: "Limited Amphibiousness",
        entries: [
          "The coral smasher can breathe air and water, but it needs to be submerged at least once every 4 hours to avoid suffocating.",
        ],
      },
      {
        name: "Shark Telepathy",
        entries: [
          "The coral smasher can magically command any shark within 120 feet of it, using a limited telepathy.",
        ],
      },
      {
        name: "Siege Monster",
        entries: [
          "The coral smasher deals double damage to objects and structures.",
        ],
      },
    ],
    action: [
      {
        name: "Multiattack",
        entries: [
          "The coral smasher makes two attacks with its warhammer, or one attack with its bite and one with its claws.",
        ],
      },
      {
        name: "Warhammer",
        entries: [
          "{5} to hit, reach 5 ft., one target. 7 ( 1d8 + 3}) bludgeoning damage.",
        ],
      },
      {
        name: "Bite",
        entries: [
          "{5} to hit, reach 5 ft., one target. 5 ( 1d4 + 3}) piercing damage.",
        ],
      },
      {
        name: "Claws",
        entries: [
          "{5} to hit, reach 5 ft., one target. 5 ( 1d4 + 3}) slashing damage.",
        ],
      },
    ],
    attachedItems: ["warhammer|phb"],
    traitTags: ["Siege Monster"],
    senseTags: ["SD"],
    actionTags: ["Multiattack"],
    languageTags: ["OTH"],
    damageTags: ["B", "P", "S"],
    miscTags: ["MW"],
    hasToken: true,
    hasFluff: true,
  },
  {
    name: "Sahuagin Deep Diver",
    source: "GoS",
    page: 250,
    otherSources: [
      {
        source: "LR",
      },
    ],
    size: ["M"],
    type: {
      type: "humanoid",
      tags: ["sahuagin"],
    },
    alignment: ["L", "E"],
    ac: [
      {
        ac: 15,
        from: ["natural armor"],
      },
    ],
    hp: {
      average: 91,
      formula: "14d8 + 28",
    },
    speed: {
      walk: 30,
      swim: 40,
    },
    str: 14,
    dex: 16,
    con: 15,
    int: 12,
    wis: 13,
    cha: 9,
    save: {
      con: "+4",
      wis: "+3",
    },
    skill: {
      perception: "+5",
      stealth: "+5",
    },
    senses: ["darkvision 120 ft."],
    passive: 15,
    languages: ["Sahuagin"],
    cr: "4",
    trait: [
      {
        name: "Blood Frenzy",
        entries: [
          "The deep diver has advantage on melee attack rolls against any creature that doesn't have all its hit points.",
        ],
      },
      {
        name: "Brine Lurker",
        entries: [
          "The deep diver has advantage on Dexterity (Stealth) checks made while submerged in water.",
        ],
      },
      {
        name: "Limited Amphibiousness",
        entries: [
          "The deep diver can breathe air and water, but it needs to be submerged at least once every 4 hours to avoid suffocating.",
        ],
      },
      {
        name: "Lure",
        entries: [
          "The deep diver can cause its lure to light up or darken at will. While the lure is lit, the deep diver sheds bright light in a 30-foot radius centered on itself and dim light for an additional 20 feet.",
        ],
      },
      {
        name: "Shark Telepathy",
        entries: [
          "The deep diver can magically command any shark within 120 feet of it, using a limited telepathy.",
        ],
      },
    ],
    action: [
      {
        name: "Multiattack",
        entries: [
          "The deep diver makes two attacks with its glaive, or one attack with its bite and two with its claws.",
        ],
      },
      {
        name: "Glaive",
        entries: [
          "{4} to hit, reach 10 ft., one target. 13 ( 2d10 + 2}) slashing damage.",
        ],
      },
      {
        name: "Bite",
        entries: [
          "{4} to hit, reach 5 ft., one target. 7 ( 1d10 + 2}) piercing damage.",
        ],
      },
      {
        name: "Claws",
        entries: [
          "{4} to hit, reach 5 ft., one target. 6 ( 1d8 + 2}) slashing damage.",
        ],
      },
      {
        name: "Light of Sekolah",
        entries: [
          "The deep diver pulses magical light from its lure. Any creature within 30 feet of the deep diver that can see the light must succeed on a {11} Wisdom saving throw or be {charmed} until the end of its next turn. A creature {charmed} in this way is {incapacitated} as it stares at the light.",
        ],
      },
    ],
    attachedItems: ["glaive|phb"],
    senseTags: ["SD"],
    actionTags: ["Multiattack"],
    languageTags: ["OTH"],
    damageTags: ["P", "S"],
    miscTags: ["AOE", "MW", "RCH"],
    conditionInflict: ["charmed"],
    hasToken: true,
    hasFluff: true,
  },
  {
    name: "Sahuagin Hatchling Swarm",
    source: "GoS",
    page: 250,
    otherSources: [
      {
        source: "LR",
      },
    ],
    size: ["L"],
    type: {
      type: "beast",
      swarmSize: "T",
    },
    alignment: ["C", "E"],
    ac: [14],
    hp: {
      average: 52,
      formula: "8d10 + 8",
    },
    speed: {
      walk: 0,
      swim: 40,
    },
    str: 9,
    dex: 18,
    con: 12,
    int: 3,
    wis: 10,
    cha: 3,
    senses: ["darkvision 120 ft."],
    passive: 10,
    resist: ["bludgeoning", "piercing", "slashing"],
    conditionImmune: [
      "charmed",
      "frightened",
      "grappled",
      "paralyzed",
      "petrified",
      "prone",
      "restrained",
      "stunned",
    ],
    cr: "3",
    trait: [
      {
        name: "Blood Frenzy",
        entries: [
          "The swarm has advantage on melee attack rolls against any creature that doesn't have all its hit points.",
        ],
      },
      {
        name: "Seething",
        entries: [
          "Once it enters combat, the swarm deals 10 slashing damage to itself at the end of its turn if it did not make an attack on that turn. This damage ignores resistance, and it cannot reduce the swarm to 0 hit points.",
        ],
      },
      {
        name: "Swarm",
        entries: [
          "The swarm can occupy another creature's space and vice versa, and it can move through any opening large enough for a Tiny creature. The swarm can't regain hit points or gain temporary hit points.",
        ],
      },
      {
        name: "Water Breathing",
        entries: ["The swarm can breathe only underwater."],
      },
    ],
    action: [
      {
        name: "Bites",
        entries: [
          "{6} to hit, reach 0 ft., one creature in the swarm's space. 14 ( 4d6}) piercing damage, or 7 ( 2d6}) piercing damage if the swarm has half of its hit points or fewer.",
        ],
      },
    ],
    traitTags: ["Water Breathing"],
    senseTags: ["SD"],
    damageTags: ["P", "S"],
    miscTags: ["MW"],
    hasToken: true,
    hasFluff: true,
  },
  {
    name: "Sahuagin High Priestess",
    source: "GoS",
    page: 251,
    otherSources: [
      {
        source: "SDW",
      },
    ],
    size: ["M"],
    type: {
      type: "humanoid",
      tags: ["sahuagin"],
    },
    alignment: ["L", "E"],
    ac: [
      {
        ac: 14,
        from: ["natural armor"],
      },
    ],
    hp: {
      average: 71,
      formula: "11d8 + 22",
    },
    speed: {
      walk: 30,
      swim: 40,
    },
    str: 14,
    dex: 12,
    con: 14,
    int: 12,
    wis: 16,
    cha: 10,
    save: {
      wis: "+6",
    },
    skill: {
      insight: "+6",
      perception: "+6",
    },
    senses: ["darkvision 120 ft."],
    passive: 16,
    languages: ["Sahuagin"],
    cr: "5",
    spellcasting: [
      {
        name: "Spellcasting",
        headerEntries: [
          "The high priestess is a 7th-level spellcaster. Her spellcasting ability is Wisdom (spell save {14}, {6} to hit with spell attacks). She has the following cleric spells prepared:",
        ],
        spells: {
          0: {
            spells: [
              "{guidance}",
              "{mending}",
              "{resistance}",
              "{thaumaturgy}",
            ],
          },
          1: {
            slots: 4,
            spells: ["{bless}", "{detect magic}", "{Guiding Bolt}"],
          },
          2: {
            slots: 3,
            spells: ["{hold person}", "{spiritual weapon} (trident)"],
          },
          3: {
            slots: 3,
            spells: [
              "{bestow curse}",
              "{fear}",
              "{mass healing word}",
              "{tongues}",
            ],
          },
          4: {
            slots: 1,
            spells: ["{banishment}"],
          },
        },
        ability: "wis",
      },
    ],
    trait: [
      {
        name: "Blood Frenzy",
        entries: [
          "The high priestess has advantage on melee attack rolls against any creature that doesn't have all its hit points.",
        ],
      },
      {
        name: "Limited Amphibiousness",
        entries: [
          "The high priestess can breathe air and water, but she needs to be submerged at least once every 4 hours to avoid suffocating.",
        ],
      },
      {
        name: "Shark Telepathy",
        entries: [
          "The high priestess can magically command any shark within 120 feet of her, using a limited telepathy.",
        ],
      },
    ],
    action: [
      {
        name: "Multiattack",
        entries: [
          "The high priestess makes two attacks with her toothsome staff, or one attack with her bite and one with her claws.",
        ],
      },
      {
        name: "Toothsome Staff",
        entries: [
          "{5} to hit, reach 5 ft., one target. 11 ( 2d8 + 2}) piercing damage.",
        ],
      },
      {
        name: "Bite",
        entries: [
          "{5} to hit, reach 5 ft., one target. 4 ( 1d4 + 2}) piercing damage.",
        ],
      },
      {
        name: "Claws",
        entries: [
          "{5} to hit, reach 5 ft., one target. 4 ( 1d4 + 2}) slashing damage.",
        ],
      },
    ],
    senseTags: ["SD"],
    actionTags: ["Multiattack"],
    languageTags: ["OTH"],
    damageTags: ["P", "S"],
    damageTagsSpell: ["N", "O", "R"],
    spellcastingTags: ["CC"],
    miscTags: ["MW"],
    hasToken: true,
    hasFluff: true,
  },
  {
    name: "Sahuagin Wave Shaper",
    source: "GoS",
    page: 251,
    size: ["M"],
    type: {
      type: "humanoid",
      tags: ["sahuagin"],
    },
    alignment: ["L", "E"],
    ac: [
      {
        ac: 14,
        from: ["natural armor"],
      },
    ],
    hp: {
      average: 60,
      formula: "11d8 + 11",
    },
    speed: {
      walk: 30,
      swim: 40,
    },
    str: 10,
    dex: 12,
    con: 12,
    int: 16,
    wis: 14,
    cha: 12,
    save: {
      int: "+6",
    },
    skill: {
      arcana: "+6",
      intimidation: "+4",
      perception: "+5",
    },
    senses: ["darkvision 120 ft."],
    passive: 15,
    languages: ["Sahuagin"],
    cr: "5",
    spellcasting: [
      {
        name: "Innate Spellcasting",
        headerEntries: [
          "The wave shaper's spellcasting ability is Intelligence (spell save {14}, {6} to hit with spell attacks). It can cast the following spells, requiring only verbal components:",
        ],
        will: ["{message}"],
        daily: {
          1: ["{comprehend languages}"],
        },
        ability: "int",
      },
    ],
    trait: [
      {
        name: "Blood Frenzy",
        entries: [
          "The wave shaper has advantage on melee attack rolls against any creature that doesn't have all its hit points.",
        ],
      },
      {
        name: "Limited Amphibiousness",
        entries: [
          "The wave shaper can breathe air and water, but it needs to be submerged at least once every 4 hours to avoid suffocating.",
        ],
      },
      {
        name: "Shark Telepathy",
        entries: [
          "The wave shaper can magically command any shark within 120 feet of it, using a limited telepathy.",
        ],
      },
    ],
    action: [
      {
        name: "Multiattack",
        entries: [
          "The wave shaper makes two attacks: one with its bite and one with its claws.",
        ],
      },
      {
        name: "Bite",
        entries: [
          "{4} to hit, reach 5 ft., one target. 10 ( 2d8 + 1}) piercing damage plus 13 ( 3d8}) cold damage.",
        ],
      },
      {
        name: "Claws",
        entries: [
          "{4} to hit, reach 5 ft., one target. 10 ( 2d8 + 1}) slashing damage plus 13 ( 3d8}) cold damage.",
        ],
      },
      {
        name: "Whirlpool (1/Day)",
        entries: [
          "The wave shaper targets a body of water at least 50 feet square and 25 feet deep, causing a whirlpool to form in the center of the area. The whirlpool forms a vortex that is 5 feet wide at the base, up to 50 feet wide at the top, 25 feet tall, and lasts for 1 minute or until the wave shaper is {incapacitated}. Any creature or object in the water and within 25 feet of the vortex is pulled 10 feet toward it. A creature can swim away from the vortex by succeeding on a {14} Strength (Athletics) check.",
          "When a creature enters the vortex for the first time on a turn or starts its turn there, it must make a {14} Strength saving throw. On a failed save, the creature takes 9 ( 2d8}) bludgeoning damage and is caught in the vortex until it ends. On a success, the creature takes half damage and isn't caught in the vortex. A creature caught in the vortex can use its action to try to swim away from the vortex as described above, but it has disadvantage on the Strength (Athletics) check to do so.",
          "The first time each turn that an object enters the vortex, the object takes 9 ( 2d8}) bludgeoning damage. This damage occurs each round it remains in the vortex.",
        ],
      },
    ],
    senseTags: ["SD"],
    actionTags: ["Multiattack"],
    languageTags: ["OTH"],
    damageTags: ["B", "C", "P", "S"],
    spellcastingTags: ["I"],
    miscTags: ["MW"],
    hasToken: true,
    hasFluff: true,
  },
  {
    name: "Sanbalet",
    isNpc: true,
    isNamedCreature: true,
    source: "GoS",
    page: 252,
    size: ["M"],
    type: {
      type: "humanoid",
      tags: ["human"],
    },
    alignment: ["N", "E"],
    ac: [11],
    hp: {
      average: 27,
      formula: "6d8",
    },
    speed: {
      walk: 30,
    },
    str: 10,
    dex: 12,
    con: 11,
    int: 16,
    wis: 13,
    cha: 14,
    skill: {
      arcana: "+5",
    },
    passive: 11,
    languages: ["Common"],
    cr: "1",
    spellcasting: [
      {
        name: "Spellcasting",
        headerEntries: [
          "Sanbalet is a 3rd-level spellcaster. His spellcasting ability is Intelligence (spell save {13}, {5} to hit with spell attacks). He has the following wizard spells prepared:",
        ],
        spells: {
          0: {
            spells: ["{dancing lights}", "{minor illusion}", "{Ray of Frost}"],
          },
          1: {
            slots: 4,
            spells: [
              "{charm person}",
              "{color spray}",
              "{Magic Missile}",
              "{silent image}",
            ],
          },
          2: {
            slots: 2,
            spells: ["{magic mouth}", "{scorching ray}"],
          },
        },
        ability: "int",
      },
    ],
    action: [
      {
        name: "Dagger",
        entries: [
          "{3} to hit, reach 5 ft. or range 20/60 ft., one target. 3 ( 1d4 + 1}) piercing damage.",
        ],
      },
    ],
    attachedItems: ["dagger|phb"],
    languageTags: ["C"],
    damageTags: ["P"],
    damageTagsSpell: ["C", "F", "O"],
    spellcastingTags: ["CW"],
    miscTags: ["MW", "RW", "THW"],
    hasToken: true,
    hasFluff: true,
  },
  {
    name: "Sauriv",
    isNpc: true,
    isNamedCreature: true,
    source: "GoS",
    page: 79,
    _copy: {
      name: "Noble",
      source: "MM",
      _trait: {
        name: "Lizardfolk",
        source: "DMG",
      },
      _mod: {
        "*": {
          mode: "replaceTxt",
          replace: "the noble",
          with: "Sauriv",
          flags: "i",
        },
      },
    },
    alignment: ["L", "N"],
    ac: [
      {
        ac: 13,
        from: ["natural armor"],
      },
    ],
    wis: 18,
    skill: {
      deception: "+7",
      insight: "+6",
      persuasion: "+7",
    },
    passive: 14,
    languages: ["Common", "Draconic"],
    traitTags: ["Hold Breath"],
    languageTags: ["C", "DR"],
    hasToken: true,
    hasFluffImages: true,
  },
  {
    name: "Shell Shark",
    source: "GoS",
    page: 252,
    size: ["M"],
    type: "monstrosity",
    alignment: ["U"],
    ac: [
      {
        ac: 18,
        from: ["shell Plate Armor"],
      },
    ],
    hp: {
      average: 32,
      formula: "5d8 + 10",
    },
    speed: {
      walk: 0,
      swim: 40,
    },
    str: 15,
    dex: 12,
    con: 14,
    int: 3,
    wis: 10,
    cha: 7,
    save: {
      str: "+6",
    },
    skill: {
      athletics: "+6",
    },
    senses: ["darkvision 120 ft."],
    passive: 10,
    cr: "2",
    trait: [
      {
        name: "Blood Frenzy",
        entries: [
          "The shark has advantage on melee attack rolls against any creature that doesn't have all its hit points.",
        ],
      },
      {
        name: "Magic Resistance",
        entries: [
          "The shark has advantage on saving throws against spells and other magical effects.",
        ],
      },
      {
        name: "Water Breathing",
        entries: ["The shark can breathe only underwater."],
      },
    ],
    action: [
      {
        name: "Multiattack",
        entries: ["The shark makes two bite attacks."],
      },
      {
        name: "Bite",
        entries: [
          "{4} to hit, reach 5 ft., one target. 13 ( 2d10 + 2}) piercing damage.",
        ],
      },
    ],
    traitTags: ["Magic Resistance", "Water Breathing"],
    senseTags: ["SD"],
    actionTags: ["Multiattack"],
    damageTags: ["P"],
    miscTags: ["MW"],
    hasToken: true,
    hasFluff: true,
  },
  {
    name: "Skeletal Alchemist",
    source: "GoS",
    page: 253,
    size: ["M"],
    type: "undead",
    alignment: ["L", "E"],
    ac: [11],
    hp: {
      average: 32,
      formula: "5d8 + 10",
    },
    speed: {
      walk: 30,
    },
    str: 9,
    dex: 13,
    con: 15,
    int: 14,
    wis: 10,
    cha: 9,
    skill: {
      arcana: "+4",
    },
    senses: ["darkvision 60 ft."],
    passive: 10,
    immune: ["poison"],
    vulnerable: ["bludgeoning"],
    conditionImmune: ["exhaustion", "poisoned"],
    languages: ["understands all languages it knew in life but can't speak"],
    cr: "1/2",
    trait: [
      {
        name: "Magic Resistance",
        entries: [
          "The skeletal alchemist has advantage on saving throws against spells and other magical effects.",
        ],
      },
    ],
    action: [
      {
        name: "Multiattack",
        entries: ["The skeletal alchemist makes two Lob Acid attacks."],
      },
      {
        name: "Claws",
        entries: [
          "{3} to hit, reach 5 ft. one target. 4 ( 1d6 + 1}) slashing damage.",
        ],
      },
      {
        name: "Lob Acid",
        entries: [
          "{3} to hit, range 30/120 ft., one target. 5 ( 1d8 + 1}) acid damage.",
        ],
      },
    ],
    traitTags: ["Magic Resistance"],
    senseTags: ["D"],
    actionTags: ["Multiattack"],
    languageTags: ["CS", "LF"],
    damageTags: ["A", "S"],
    miscTags: ["MW", "RW"],
    hasToken: true,
    hasFluff: true,
    hasFluffImages: true,
  },
  {
    name: "Skeletal Juggernaut",
    source: "GoS",
    page: 253,
    otherSources: [
      {
        source: "IMR",
      },
    ],
    size: ["L"],
    type: "undead",
    alignment: ["L", "E"],
    ac: [
      {
        ac: 13,
        from: ["armor scraps"],
      },
    ],
    hp: {
      average: 142,
      formula: "19d10 + 38",
    },
    speed: {
      walk: 30,
    },
    str: 16,
    dex: 14,
    con: 15,
    int: 6,
    wis: 8,
    cha: 5,
    senses: ["darkvision 60 ft."],
    passive: 9,
    immune: ["poison"],
    vulnerable: ["bludgeoning"],
    conditionImmune: ["exhaustion", "poisoned"],
    cr: "5",
    trait: [
      {
        name: "Disassemble",
        entries: [
          "If the juggernaut is reduced to 0 hit points, twelve skeletons rise from its remains.",
        ],
      },
      {
        name: "Falling Apart",
        entries: [
          "If the juggernaut does not have all of its hit points at the start of its turn, it loses 10 hit points.",
        ],
      },
    ],
    action: [
      {
        name: "Multiattack",
        entries: ["The juggernaut makes two claws attacks."],
      },
      {
        name: "Claws",
        entries: [
          "{6} to hit, reach 10 ft., one target. 12 ( 2d8 + 3}) slashing damage.",
        ],
      },
      {
        name: "Avalanche of Bones {@recharge 5}",
        entries: [
          "The juggernaut collapses into a large heap before quickly reforming. Each creature within 10 feet of the juggernaut must make a {14} Dexterity saving throw, taking 18 ( 4d8}) bludgeoning damage on a failed save, or half as much damage on a successful one. A creature that fails this saving throw is also knocked {prone}.",
        ],
      },
    ],
    senseTags: ["D"],
    actionTags: ["Multiattack"],
    damageTags: ["B", "S"],
    miscTags: ["MW", "RCH"],
    hasToken: true,
    hasFluff: true,
  },
  {
    name: "Skeletal Swarm",
    source: "GoS",
    page: 254,
    otherSources: [
      {
        source: "DC",
      },
      {
        source: "IMR",
      },
    ],
    size: ["L"],
    type: {
      type: "undead",
      swarmSize: "M",
    },
    alignment: ["L", "E"],
    ac: [
      {
        ac: 13,
        from: ["armor scraps"],
      },
    ],
    hp: {
      average: 60,
      formula: "8d10 + 16",
    },
    speed: {
      walk: 30,
    },
    str: 12,
    dex: 14,
    con: 15,
    int: 6,
    wis: 8,
    cha: 5,
    senses: ["darkvision 60 ft."],
    passive: 9,
    resist: ["slashing", "piercing"],
    immune: ["poison"],
    vulnerable: ["bludgeoning"],
    conditionImmune: [
      "charmed",
      "exhaustion",
      "frightened",
      "paralyzed",
      "petrified",
      "poisoned",
      "prone",
      "restrained",
      "stunned",
    ],
    cr: "2",
    trait: [
      {
        name: "Deafening Clatter",
        entries: ["Creatures are {deafened} while in the swarm's space."],
      },
      {
        name: "Swarm",
        entries: [
          "The swarm can occupy another creature's space and vice versa, and the swarm can move through any opening large enough for a Small humanoid. The swarm can't regain hit points or gain temporary hit points.",
        ],
      },
    ],
    action: [
      {
        name: "Slash",
        entries: [
          "{4} to hit, reach 0 ft., one target in the swarm's space. 11 ( 2d8 + 2}) slashing damage, or 6 ( 1d8 + 2}) slashing damage if the swarm has half of its hit points or fewer.",
        ],
      },
    ],
    senseTags: ["D"],
    damageTags: ["S"],
    miscTags: ["MW"],
    hasToken: true,
    hasFluff: true,
  },
  {
    name: "Skum",
    source: "GoS",
    page: 254,
    size: ["M"],
    type: "aberration",
    alignment: ["L", "E"],
    ac: [
      {
        ac: 14,
        from: ["natural armor"],
      },
    ],
    hp: {
      average: 93,
      formula: "11d8 + 44",
    },
    speed: {
      walk: 20,
      swim: 40,
    },
    str: 19,
    dex: 11,
    con: 18,
    int: 7,
    wis: 12,
    cha: 9,
    skill: {
      perception: "+4",
    },
    senses: ["darkvision 120 ft."],
    passive: 14,
    resist: ["psychic"],
    languages: ["Common", "Deep Speech", "telepathy 60 ft."],
    cr: "5",
    trait: [
      {
        name: "Abolethic Vassal",
        entries: ["The skum is permanently {charmed} by its aboleth master."],
      },
      {
        name: "Amphibious",
        entries: ["The skum can breathe air and water."],
      },
      {
        name: "Psychic Conditioning",
        entries: [
          "The skum is immune to the {frightened} and {charmed} conditions unless they are from effects created by an aboleth.",
        ],
      },
      {
        name: "Water Dependency",
        entries: [
          "The skum takes 6 ( 1d12}) acid damage every 10 minutes it goes without exposure to water.",
        ],
      },
    ],
    action: [
      {
        name: "Multiattack",
        entries: [
          "The skum makes three attacks: two with its trident and one with its Mind-Breaking Touch.",
        ],
      },
      {
        name: "Trident",
        entries: [
          "{7} to hit, reach 5 ft., one target. 7 ( 1d6 + 4}) piercing damage.",
        ],
      },
      {
        name: "Mind-Breaking Touch",
        entries: [
          "{7} to hit, reach 5 ft., one target. 18 ( 4d8}) psychic damage, and the target has disadvantage on Wisdom saving throws until the end of the skum's next turn.",
        ],
      },
    ],
    attachedItems: ["trident|phb"],
    traitTags: ["Amphibious"],
    senseTags: ["SD"],
    actionTags: ["Multiattack"],
    languageTags: ["C", "DS", "TP"],
    damageTags: ["A", "P", "Y"],
    miscTags: ["MW"],
    hasToken: true,
    hasFluff: true,
    hasFluffImages: true,
  },
  {
    name: "Thousand Teeth",
    shortName: true,
    isNpc: true,
    isNamedCreature: true,
    source: "GoS",
    page: 256,
    size: ["L"],
    type: "monstrosity",
    alignment: ["N", "E"],
    ac: [
      {
        ac: 12,
        from: ["natural armor"],
      },
    ],
    hp: {
      average: 93,
      formula: "11d10 + 33",
    },
    speed: {
      walk: 30,
      swim: 50,
    },
    str: 19,
    dex: 10,
    con: 17,
    int: 2,
    wis: 10,
    cha: 7,
    save: {
      str: "+7",
      con: "+6",
    },
    skill: {
      athletics: "+7",
      stealth: "+3",
    },
    passive: 10,
    cr: "6",
    trait: [
      {
        name: "Hold Breath",
        entries: ["Thousand Teeth can hold its breath for 30 minutes."],
      },
      {
        name: "Legendary Resistance (2/Day)",
        entries: [
          "If Thousand Teeth fails a saving throw, it can choose to succeed instead.",
        ],
      },
    ],
    action: [
      {
        name: "Multiattack",
        entries: [
          "Thousand Teeth makes two attacks: one with its bite and one with its tail.",
        ],
      },
      {
        name: "Bite",
        entries: [
          "{7} to hit, reach 5 ft., one target. 15 ( 2d10 + 4}) piercing damage.",
        ],
      },
      {
        name: "Tail",
        entries: [
          "{7} to hit, reach 10 ft., one target. 8 ( 1d8 + 4}) bludgeoning damage. If the target is a creature, it must succeed on a {15} Strength saving throw or be knocked {prone}.",
        ],
      },
    ],
    legendary: [
      {
        name: "Detect",
        entries: ["Thousand Teeth makes a Wisdom (Perception) check."],
      },
      {
        name: "Lunge",
        entries: ["Thousand Teeth moves up to half its speed."],
      },
      {
        name: "Bite (Costs 2 Actions)",
        entries: ["Thousand Teeth makes a bite attack."],
      },
    ],
    traitTags: ["Hold Breath", "Legendary Resistances"],
    actionTags: ["Multiattack"],
    damageTags: ["B", "P"],
    miscTags: ["MW", "RCH"],
    conditionInflict: ["prone"],
    hasToken: true,
    hasFluff: true,
    hasFluffImages: true,
  },
  {
    name: "Vampiric Jade Statue",
    source: "GoS",
    page: 256,
    size: ["L"],
    type: "construct",
    alignment: ["U"],
    ac: [
      {
        ac: 14,
        from: ["natural armor"],
      },
    ],
    hp: {
      average: 114,
      formula: "12d10 + 48",
    },
    speed: {
      walk: 30,
    },
    str: 16,
    dex: 14,
    con: 18,
    int: 6,
    wis: 10,
    cha: 5,
    senses: ["darkvision 60 ft."],
    passive: 10,
    immune: ["lightning", "poison"],
    vulnerable: ["force"],
    conditionImmune: [
      "charmed",
      "exhaustion",
      "frightened",
      "paralyzed",
      "petrified",
      "poisoned",
    ],
    languages: ["understands the languages of its creator but can't speak"],
    cr: "8",
    trait: [
      {
        name: "Immutable Form",
        entries: [
          "The statue is immune to any spell or effect that would alter its form.",
        ],
      },
      {
        name: "Legendary Resistance (3/Day)",
        entries: [
          "If the statue fails a saving throw, it can choose to succeed instead.",
        ],
      },
    ],
    action: [
      {
        name: "Multiattack",
        entries: [
          "The statue makes three attacks: one with its bite and two with its claws.",
        ],
      },
      {
        name: "Bite",
        entries: [
          "{6} to hit, reach 5 ft., one target. 10 ( 2d6 + 3}) piercing damage. If the target is a creature, that creature becomes cursed by the statue. The curse lasts for 10 minutes. While the creature is cursed, the statue has advantage on all attacks against it.",
        ],
      },
      {
        name: "Claws",
        entries: [
          "{6} to hit, reach 5 ft., one target. 10 ( 2d6 + 3}) slashing damage.",
        ],
      },
    ],
    legendary: [
      {
        name: "Bite",
        entries: ["The statue makes one bite attack."],
      },
      {
        name: "Blood Reaper",
        entries: [
          "All creatures currently cursed by the statue and within 20 feet of it take 5 necrotic damage.",
        ],
      },
      {
        name: "Move",
        entries: [
          "The statue moves up to its speed without provoking opportunity attacks.",
        ],
      },
    ],
    traitTags: ["Immutable Form", "Legendary Resistances"],
    senseTags: ["D"],
    actionTags: ["Multiattack"],
    languageTags: ["CS"],
    damageTags: ["N", "P", "S"],
    miscTags: ["MW"],
    hasToken: true,
    hasFluff: true,
  },
  {
    name: "Yalaga Maladwyn",
    isNpc: true,
    isNamedCreature: true,
    source: "GoS",
    page: 226,
    _copy: {
      name: "Drow Priestess of Lolth",
      source: "MM",
      _mod: {
        "*": {
          mode: "replaceTxt",
          replace: "the drow",
          with: "Yalaga",
          flags: "i",
        },
        trait: {
          mode: "removeArr",
          names: "Fey Ancestry",
        },
        action: {
          mode: "removeArr",
          names: "Summon Demon (1/Day)",
        },
      },
    },
    type: "undead",
    traitTags: ["Sunlight Sensitivity"],
    damageTags: ["I", "P"],
    hasToken: true,
  },
];
